import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AlertsService } from 'src/app/services/alerts.service';
import { BlockUiHandlerService } from 'src/app/services/block-ui-handler.service';
import { TemplatesService } from 'src/app/services/templates.service';
import { FilesService } from 'src/app/services/files.service';
import { StorageService } from 'src/app/services/storage.service';
import { ITemplateDocument } from 'src/app/models/i-template-document';
import { ITemplate } from 'src/app/models/i-template';
import { IUser } from 'src/app/models';
import { Constants } from 'src/app/common';
import { ActivatedRoute } from '@angular/router';
import { DatePipe, DecimalPipe } from '@angular/common';
import { Utils } from 'src/app/common/utils';
import { DateToWordsPipe } from 'src/app/pipes/date-to-words.pipe';
import { NumberToWordsPipe } from 'src/app/pipes/number-to-words.pipe';
import { CommonService } from '../../services/common.service';
import { ALERTS, TEMPLATES } from '../../common/constants';
import { FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { faGenderless, faMars, faUser, faVenus, faUsers } from '@fortawesome/free-solid-svg-icons';
import { forkJoin, merge, Observable, OperatorFunction, Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, filter, finalize, map } from 'rxjs/operators';
import { NgbTypeahead } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-generate-template',
  templateUrl: './generate-template.component.html',
  styleUrls: ['./generate-template.component.css']
})
export class GenerateTemplateComponent implements OnInit {
  // Listas para llenar desplegables
  Monedas: string[];
  Provincias: {id: number, value: string}[];
  Duplicados: string[];
  Horizontales: string[];
  CantidadEstadosCiviles: string[];
  TiposIdentificacion: string[];
  GendersType: {[id: string] : string };
  GradosHipoteca: string[];
  GradosPrendas: string[];
  Clases: {value: string, description: string, codes: {value: string, description: string}[]}[];

  // Variables Formato activo
  ActiveTemplateTypeId: number;
  ActiveTemplate: ITemplate;
  ActiveTemplateDocuments: {[id: string] : ITemplateDocument };
  ActiveTemplateTexts: {[id: string] : string };
  ActiveTemplateKey: string;

  // Usuario activo
  ActiveUser: IUser;
  SelectTab: string;
  
  //Formularios para formatos FIDEICOMISO
  FideicomisoCesionarioForm: FormGroup;
  FideicomisoOriginalForm: FormGroup;
  FideicomisoSociedadForm: FormGroup;
  FideicomisoGeneralForm: FormGroup;
  FideicomisoFincaForm: FormGroup;
  FideicomisoFiduciariaForm: FormGroup;
  FideicomisoApoderadoForm: FormGroup;
  FideicomisoDeudorForm: FormGroup;

  //Formularios para formatos HIPOTECA
  HipotecaDeudorForm: FormGroup;
  HipotecaGeneralForm: FormGroup;
  HipotecaPropietarioForm: FormGroup;
  HipotecaSociedadForm: FormGroup;
  HipotecaFincaForm: FormGroup;

  //Formularios para formatos PRENDAS
  PrendasDeudorForm: FormGroup;
  PrendasSociedadDeudorForm: FormGroup;
  PrendasVendedorForm: FormGroup;
  PrendasSociedadVendedorForm: FormGroup;
  PrendasCompradorForm: FormGroup;
  PrendasSociedadCompradorForm: FormGroup;
  PrendasFiadorForm: FormGroup;
  PrendasGeneralForm: FormGroup;
  PrendasVehiculoForm: FormGroup;
  

  // General Formularios
  Forms: FormGroup[];

  // JSONS Cargados
  Blocks: object;

  GenderWords: object;

  Codes: {value: string, description: string}[];

  @ViewChild('VehicleClass') VehicleClass: NgbTypeahead;
  
	FocusClass$ = new Subject<string>();

  constructor(
    private activeRoute: ActivatedRoute,
    private templatesService: TemplatesService,
    private filesService: FilesService,
    private storageService: StorageService,
    private blockUiHanddler: BlockUiHandlerService,
    private alertsService: AlertsService,
    private datePipe: DatePipe,
    private decimalPipe: DecimalPipe,
    private dateToWordsPipe: DateToWordsPipe, 
    private numberToWordsPipe: NumberToWordsPipe,
    private formBuilder: FormBuilder,
    private commonService: CommonService,
    library: FaIconLibrary
    ) {
      library.addIcons(faMars, faVenus, faGenderless, faUser, faUsers) 
  }
  ngOnInit(): void {
    forkJoin({
      blocks: this.filesService.GetJson('blocks'),
      genders: this.filesService.GetJson('genders'),
      clases: this.filesService.GetJson('clases')
    }).pipe(finalize(() => this.InitVariables())).subscribe(next => {
      this.Blocks = next.blocks;
      this.GenderWords = next.genders;
      this.Clases = next.clases;
    },
    error => {
      this.alertsService.ShowBigCenteredAlert(error, ALERTS.error);
      this.InitVariables();
    });
  }

  InitVariables(): void {
    this.Monedas = Constants.Monedas;
    this.Provincias = Constants.Provincias;
    this.Duplicados = Constants.Duplicados;
    this.Horizontales = Constants.Horizontales;
    this.CantidadEstadosCiviles = Constants.CantidadEstadosCiviles;
    this.TiposIdentificacion = Constants.TiposIdentificacion;
    this.GendersType = Constants.Genders;
    this.GradosHipoteca = Constants.GradosHipoteca;
    this.GradosPrendas = Constants.GradosPrendas;
    this.Codes = [];

    // Init text on void
    this.ActiveTemplateTexts = {};

    // Init templates
    this.ActiveTemplateDocuments = {};
    
    this.Forms = [];

    this.LoadActiveUser();
    this.LoadActiveTemplate();
  }

  async LoadLocalTemplateText(key: string){
    let TemplateText = await this.filesService.GetFile(key).toPromise();
    this.ActiveTemplateTexts[key] = TemplateText;
    this.ActiveTemplateDocuments[key].RawText = TemplateText;
    // Fideicomitente original
    this.ActiveTemplateTexts[key] = this.ReplaceTextVaribles(this.ActiveTemplateTexts[key], 'bac.fideicomitente_original', this.Blocks['FIDEICOMISO']['FIDEICOMITENTE_ORIGINAL']);
    this.ActiveTemplateTexts[key] = this.ReplaceTextVaribles(this.ActiveTemplateTexts[key], 'bac.sociedad_fideicomitente_original', this.Blocks['FIDEICOMISO']['SOCIEDAD_FIDEICOMITENTE_ORIGINAL']);
    // Propietario registral
    this.ActiveTemplateTexts[key] = this.ReplaceTextVaribles(this.ActiveTemplateTexts[key], 'bac.Propietario', this.Blocks['HIPOTECA']['PROPIETARIO_REGISTRAL']);
    this.ActiveTemplateTexts[key] = this.ReplaceTextVaribles(this.ActiveTemplateTexts[key], 'bac.sociedad_Propietario', this.Blocks['HIPOTECA']['SOCIEDAD_PROPIETARIO_REGISTRAL']);
  }

  LoadActiveUser(){
    let CurrentUser = this.storageService.GetCurrentSession();
    this.ActiveUser = {
      Id: CurrentUser.Id,
      Email: CurrentUser.UserName,
      Password: '',
      Active: true
    };
  }

  LoadActiveTemplate(){
    this.ActiveTemplateTypeId = this.activeRoute.snapshot.params['type'];

    if(this.ActiveTemplateTypeId){
      this.templatesService.GetDocumentTypesByTemplate(this.ActiveTemplateTypeId).subscribe(response => {
        if(response.Result){
          let TemplateId = this.activeRoute.snapshot.params['template'];

          if(TemplateId){
            this.ActiveTemplate = {
              Id: TemplateId,
              TemplateTypeId: this.ActiveTemplateTypeId,
              Active: true
            };

            this.ActiveTemplateKey = response.Data.find(x => x).TemplateType.Name;
            this.LoadActiveForms();
      
            this.blockUiHanddler.Start(1, 'Cargando formatos...')
            this.templatesService.GetTemplateDocumentsByTemplateId(TemplateId).subscribe(req => {
              this.blockUiHanddler.Stop();
              if(req.Result){
                // Obtenemos el formato guardado mas recientemente, con las variables mas actualizadas y completas
                let lastUpdateTemplateDocument = req.Data.reduce((p, c) => p.UpdateDate > c.UpdateDate ? p : c);

                // Repasamos los tipos de documentos asociados al formato
                response.Data.forEach(DocumentType => {
                  let key = `${DocumentType.TemplateType.Name.replace(' ','_')}@${DocumentType.Name.replace(' ','_')}`;
                  
                  // Buscamos si el formato fue traido de la base de datos
                  let ActiveTemplateDocument = req.Data.find(
                    x => x.Template.TemplateType.Name === DocumentType.TemplateType.Name
                    && x.DocumentType.Name === DocumentType.Name
                  );
                  
                  if(ActiveTemplateDocument){
                    if(!this.SelectTab) this.SelectTab = DocumentType.Name;
                    this.ActiveTemplateDocuments[key] = ActiveTemplateDocument;
      
                    //Texto original si existe
                    if(this.ActiveTemplateDocuments[key].RawText)
                      this.ActiveTemplateTexts[key] = ActiveTemplateDocument.RawText;    

                    // Reemplazo de variables desde BD
                    if(this.ActiveTemplateDocuments[key].JsonVariables){
                      let Variables: { [name: string]: string } = JSON.parse(lastUpdateTemplateDocument.JsonVariables)

                      // Fideicomitente original
                      if(Variables['bac.cedula_Fideicomitente_Original']){
                        this.ActiveTemplateTexts[key] = this.ReplaceTextVaribles(this.ActiveTemplateTexts[key], 'bac.fideicomitente_original', this.Blocks['FIDEICOMISO']['FIDEICOMITENTE_ORIGINAL']);
                        this.ActiveTemplateTexts[key] = this.ReplaceTextVaribles(this.ActiveTemplateTexts[key], 'bac.sociedad_fideicomitente_original', '');
                      }
                      if(Variables['bac.cedula_Sociedad_Fideicomitente_Original']){
                        this.ActiveTemplateTexts[key] = this.ReplaceTextVaribles(this.ActiveTemplateTexts[key], 'bac.fideicomitente_original', ''); 
                        this.ActiveTemplateTexts[key] = this.ReplaceTextVaribles(this.ActiveTemplateTexts[key], 'bac.sociedad_fideicomitente_original', this.Blocks['FIDEICOMISO']['SOCIEDAD_FIDEICOMITENTE_ORIGINAL']);
                      }

                      // Propietario registral
                      if(Variables['bac.cedula_propietario_registral']){
                        this.ActiveTemplateTexts[key] = this.ReplaceTextVaribles(this.ActiveTemplateTexts[key], 'bac.Propietario', this.Blocks['HIPOTECA']['PROPIETARIO_REGISTRAL']);
                        this.ActiveTemplateTexts[key] = this.ReplaceTextVaribles(this.ActiveTemplateTexts[key], 'bac.sociedad_Propietario', '');
                      }
                      if(Variables['bac.cedula_Sociedad_Propietario']){
                        this.ActiveTemplateTexts[key] = this.ReplaceTextVaribles(this.ActiveTemplateTexts[key], 'bac.Propietario', ''); 
                        this.ActiveTemplateTexts[key] = this.ReplaceTextVaribles(this.ActiveTemplateTexts[key], 'bac.sociedad_Propietario', this.Blocks['HIPOTECA']['SOCIEDAD_PROPIETARIO_REGISTRAL']);
                      }

                      
                      if(this.ActiveTemplateKey === TEMPLATES.PRENDAS){

                        let incisos = '';
                        let debtor = '';
                        let buyer = '';
                        let seller = '';
                        let guarantor = '';

                        if (Variables['bac.cedula_deudor'] || Variables['bac.cedula_Comprador']){
                          if (Variables['bac.cedula_deudor'] === Variables['bac.cedula_Comprador']){
                            debtor = this.Blocks['PRENDAS']['APPEARING']['DEBTOR_1'];
                          } else {
                            if (Variables['bac.cedula_deudor']){
                              debtor = this.Blocks['PRENDAS']['APPEARING']['DEBTOR_2'];
                            }
                            if (Variables['bac.cedula_Comprador']){
                              buyer = this.Blocks['PRENDAS']['APPEARING']['BUYER'];
                            }
                          }
                        }

                        if (Variables['bac.cedula_Sociedad_Deudor'] || Variables['bac.cedula_Sociedad_Comprador']){
                          if (Variables['bac.cedula_Sociedad_Deudor'] === Variables['bac.cedula_Sociedad_Comprador']){
                            debtor = this.Blocks['PRENDAS']['APPEARING']['DEBTOR_SOCIETY_1'];
                          } else {
                            if (Variables['bac.cedula_Sociedad_Deudor']){
                              debtor = this.Blocks['PRENDAS']['APPEARING']['DEBTOR_SOCIETY_2'];
                            }
                            if (Variables['bac.cedula_Sociedad_Comprador']){
                              buyer = this.Blocks['PRENDAS']['APPEARING']['BUYER_SOCIETY'];
                            }
                          }
                        }

                        if (Variables['bac.cedula_vendedor']){
                          seller = this.Blocks['PRENDAS']['APPEARING']['SELLER'];
                        }

                        if (Variables['bac.cedula_Sociedad_Vendedor']){
                          seller = this.Blocks['PRENDAS']['APPEARING']['SELLER_SOCIETY'];
                        }

                        if (Variables['bac.check_fiador']){
                          if(Variables['bac.cedula_Fiador'] !== Variables['bac.cedula_apoderado_Deudor']){
                            guarantor = this.Blocks['PRENDAS']['APPEARING']['GUARANTOR'];
                          } else {
                            debtor = this.Blocks['PRENDAS']['APPEARING']['DEBTOR_SOCIETY_GUARANTOR'];
                          }
                        }

                        let letters = ['D','C','B','A'];

                        if(debtor){
                          incisos += `${letters.pop()}) ${debtor}`;
                        }
                        if(buyer){
                          incisos += `${letters.pop()}) ${buyer}`;
                        }
                        if(seller){
                          incisos += `${letters.pop()}) ${seller}`;
                        }
                        if(guarantor){
                          incisos += `${letters.pop()}) ${guarantor}`;
                        }

                        this.ActiveTemplateTexts[key] = this.ReplaceTextVaribles(this.ActiveTemplateTexts[key], 'bac.incisos', incisos);

                        // Fecha inicio despues del dia 7
                        if(Variables['bac.fecha_firma']){
                          try {
                            let fechaPrenda = new Date(this.datePipe.transform(Variables['bac.fecha_firma']))
                            
                            if(fechaPrenda.getDate() >= 7){
                              this.ActiveTemplateTexts[key] = this.ReplaceTextVaribles(this.ActiveTemplateTexts[key], 'bac.clausula_fechadespues7', this.Blocks['PRENDAS']['DATE_NEXT_SEVEN_CLAUSULE']);
                            } else {
                              this.ActiveTemplateTexts[key] = this.ReplaceTextVaribles(this.ActiveTemplateTexts[key], 'bac.clausula_fechadespues7', '');
                            }
                          } catch (ex){
                            console.log(ex);
                          }
                        } else {
                          this.ActiveTemplateTexts[key] = this.ReplaceTextVaribles(this.ActiveTemplateTexts[key], 'bac.clausula_fechadespues7', '');
                        }

                        if(Variables['bac.fecha_Inicio_Prenda']){
                          try {
                            let fechaPrenda = new Date(this.datePipe.transform(Variables['bac.fecha_Inicio_Prenda']))
                            let month = Constants.Months[fechaPrenda.getMonth()];
                            let year = this.numberToWordsPipe.transform(fechaPrenda.getFullYear()+2);

                            this.ActiveTemplateTexts[key] = this.ReplaceTextVaribles(this.ActiveTemplateTexts[key], 'bac.mes_finicio', month);
                            this.ActiveTemplateTexts[key] = this.ReplaceTextVaribles(this.ActiveTemplateTexts[key], 'bac.año_finicio', year);

                          } catch (ex){
                            console.log(ex);
                          }
                        } else {
                          this.ActiveTemplateTexts[key] = this.ReplaceTextVaribles(this.ActiveTemplateTexts[key], 'bac.mes_finicio', '');
                          this.ActiveTemplateTexts[key] = this.ReplaceTextVaribles(this.ActiveTemplateTexts[key], 'bac.año_finicio', '');
                        }
                      }

                      this.Forms.forEach(form => {
                        for(let variable in form.controls){
                          form.controls[variable].setValue(Variables[variable]);
                          if(variable === 'bac.clase_vehiculo'){
                            this.UpdateCodes();
                          }
                          this.ActiveTemplateTexts[key] = this.ReplaceVariables(this.ActiveTemplateTexts[key], variable, Variables);
                        }
                      });
                    }
                  } else {
                    // En caso que el documento no exista para ese formato se carga por defecto
                    this.ActiveTemplateDocuments[key] = {
                      Id: 0,
                      CreateUserId: this.ActiveUser.Id,
                      UpdateUserId: this.ActiveUser.Id,
                      TemplateId: TemplateId,
                      DocumentTypeId: DocumentType.Id,
                      CreateUser: this.ActiveUser,
                      UpdateUser: this.ActiveUser,
                      UpdateDate: new Date(),
                      CreateDate: new Date(),
                      FriendlyName: '',
                      AzureLink: '',
                      JsonVariables: '',
                      RawText: '',
                      Counter: 1,
                      Active: true,
                      DocumentType: DocumentType
                    }
                    this.LoadLocalTemplateText(key);
                  }
                });
              } else {
                this.alertsService.ShowSmallCornerAlert('Ocurrió un error al cargar los formatos guardados', ALERTS.error);
              }
            }, err => {
              this.blockUiHanddler.Stop();
              this.alertsService.ShowSmallCornerAlert(err, ALERTS.error);
            })
          } else {
            this.ActiveTemplateKey = response.Data.find(x => x).TemplateType.Name;
            this.LoadActiveForms();

            response.Data.forEach(DocumentType => {
              if(!this.SelectTab) this.SelectTab = DocumentType.Name;
              let key = `${DocumentType.TemplateType.Name.replace(' ','_')}@${DocumentType.Name.replace(' ','_')}`;

              this.ActiveTemplateDocuments[key] = {
                Id: 0,
                CreateUserId: this.ActiveUser.Id,
                UpdateUserId: this.ActiveUser.Id,
                TemplateId: 0,
                DocumentTypeId: DocumentType.Id,
                CreateUser: this.ActiveUser,
                UpdateUser: this.ActiveUser,
                UpdateDate: new Date(),
                CreateDate: new Date(),
                FriendlyName: '',
                AzureLink: '',
                JsonVariables: '',
                RawText: '',
                Counter: 1,
                Active: true,
                DocumentType: DocumentType
              }
              this.LoadLocalTemplateText(key);
            })
          }
        }
      }, err => {
        this.alertsService.ShowSmallCornerAlert(err, ALERTS.error);
      })
    } else {
      this.alertsService.ShowBigCenteredAlert("El tipo de formato no esta configurado", ALERTS.error);
    }
  }
  
  // RESET FIDEICOMISO FORMS
  ResetFideicomisoCesionarioForm(PreserveKey?: boolean, PreserveType?: boolean): void {
    let formIndex = this.Forms.findIndex(x => x === this.FideicomisoCesionarioForm);

    this.FideicomisoCesionarioForm = this.formBuilder.group({
      "bac.Genero_fideicomitente_cesionario": ['', Validators.required],
      "bac.tipo_identificacion_Fideicomitente_Cesionario": [
        (PreserveType) ? this.FideicomisoCesionarioForm.controls['bac.tipo_identificacion_Fideicomitente_Cesionario'].value : 'cédula de identidad', 
        Validators.required
      ],
      "bac.cedula_Firmante_Fideicomitente_Cesionario": [
        (PreserveKey) ? this.FideicomisoCesionarioForm.controls['bac.cedula_Firmante_Fideicomitente_Cesionario'].value : '', 
        Validators.required
      ],
      "tse.nombre_Firmante_Fideicomitente_Cesionario": ['', Validators.required],
      "tse.nacionalidad_Firmante_Fideicomitente_Cesionario": ['', Validators.required],
      "tse.estadocivil_Firmante_Fideicomitente_Cesionario": ['', Validators.required],
      "bac.cantidad_estadosciviles_Fideicomitente_Cesionario": ['', Validators.required],
      "bac.profesion_Firmante_Fideicomitente_Cesionario": ['', Validators.required],
      "bac.domicilio_Firmante_Fideicomitente_Cesionario": ['', Validators.required]
    });

    if(formIndex >= 0) this.Forms[formIndex] = this.FideicomisoCesionarioForm;
  }

  ResetFideicomisoOriginalForm(PreserveKey?: boolean, PreserveType?: boolean): void {
    let formIndex = this.Forms.findIndex(x => x === this.FideicomisoOriginalForm);

    this.FideicomisoOriginalForm = this.formBuilder.group({
      "bac.Genero_fideicomitente_original": ['', Validators.required],
      "bac.tipo_identificacion_Fideicomitente_Original": [
        (PreserveType) ? this.FideicomisoOriginalForm.controls['bac.tipo_identificacion_Fideicomitente_Original'].value : 'cédula de identidad', 
        Validators.required
      ],
      "bac.cedula_Fideicomitente_Original": [
        (PreserveKey) ? this.FideicomisoOriginalForm.controls['bac.cedula_Fideicomitente_Original'].value : '', 
        Validators.required
      ],
      "tse.nombre_Firmante_Fideicomitente_Original": ['', Validators.required],
      "tse.nacionalidad_Firmante_Fideicomitente_Original": ['', Validators.required],
      "tse.estadocivil_Firmante_Fideicomitente_Original": ['', Validators.required],
      "bac.cantidad_estadosciviles_Fideicomitente_Original": ['', Validators.required],
      "bac.profesion_Fideicomitente_Original": ['', Validators.required],
      "bac.domicilio_Fideicomitente_Original": ['', Validators.required]
    });

    if(formIndex >= 0) this.Forms[formIndex] = this.FideicomisoOriginalForm;
  }

  ResetFideicomisoSociedadForm(PreserveKey?: boolean, PreserveType?: boolean): void {
    let formIndex = this.Forms.findIndex(x => x === this.FideicomisoSociedadForm);

    this.FideicomisoSociedadForm = this.formBuilder.group({
      "bac.cedula_Sociedad_Fideicomitente_Original_Tipo": [
        (PreserveKey || PreserveType) ? this.FideicomisoSociedadForm.controls['bac.cedula_Sociedad_Fideicomitente_Original_Tipo'].value : '', 
        Validators.required
      ],
      "bac.cedula_Sociedad_Fideicomitente_Original_Clase": [
        (PreserveKey || PreserveType) ? this.FideicomisoSociedadForm.controls['bac.cedula_Sociedad_Fideicomitente_Original_Clase'].value : '', 
        Validators.required
      ],
      "bac.cedula_Sociedad_Fideicomitente_Original_Consecutivo": [
        (PreserveKey || PreserveType) ? this.FideicomisoSociedadForm.controls['bac.cedula_Sociedad_Fideicomitente_Original_Consecutivo'].value : '', 
        Validators.required
      ],
      "bac.cedula_Sociedad_Fideicomitente_Original": [
        (PreserveType) ? this.FideicomisoSociedadForm.controls['bac.cedula_Sociedad_Fideicomitente_Original'].value : '', 
        Validators.required
      ],
      "rnp.razon_Social_Sociedad_Fideicomitente_Original": [
        (PreserveType) ? this.FideicomisoSociedadForm.controls['rnp.razon_Social_Sociedad_Fideicomitente_Original'].value : '', 
        Validators.required
      ],
      "bac.domicilio_Sociedad_Fideicomitente_Original": [
        (PreserveType) ? this.FideicomisoSociedadForm.controls['bac.domicilio_Sociedad_Fideicomitente_Original'].value : '', 
        Validators.required
      ],
      "bac.Genero_apoderado_fideicomitente_original": [
        (PreserveType) ? this.FideicomisoSociedadForm.controls['bac.Genero_apoderado_fideicomitente_original'].value : '', 
        Validators.required
      ],
      "bac.Tipo_identificacion_apoderado_fideicomitente_original": [
        (PreserveType) ? this.FideicomisoSociedadForm.controls['bac.Tipo_identificacion_apoderado_fideicomitente_original'].value : 'cédula de identidad', 
        Validators.required
      ],
      "bac.cedula_apoderado_fideicomitente_original": [
        (PreserveKey) ? this.FideicomisoSociedadForm.controls['bac.cedula_apoderado_fideicomitente_original'].value : '', 
        Validators.required
      ],
      "tse.nacionalidad_apoderado_fideicomitente_original": ['', Validators.required],
      "tse.nombre_apoderado_fideicomitente_original": ['', Validators.required],
      "tse.estadocivil_apoderado_fideicomitente_original": ['', Validators.required],
      "bac.cantidad_estadocivil_apoderado_fideicomitente_original": ['', Validators.required],
      "bac.profesion_apoderado_fideicomitente_Original": ['', Validators.required],
      "bac.domicilio_apoderado_fideicomitente_original": ['', Validators.required]
    });

    if(formIndex >= 0) this.Forms[formIndex] = this.FideicomisoSociedadForm;
  }

  ResetFideicomisoGeneralForm(): void {
    let formIndex = this.Forms.findIndex(x => x === this.FideicomisoGeneralForm);

    this.FideicomisoGeneralForm = this.formBuilder.group({
      "bac.moneda": ['', Validators.required],
      "bac.suma_Prestamo": ['0', Validators.required],
      "bac.cuota_Inicial_Prestamo": ['0', Validators.required],
      "bac.plazo_Meses_Prestamo": ['0', Validators.required],
      "bac.fecha_Inicio_Prestamo": ['', Validators.required],
      "bac.fecha_Vencimiento_Prestamo": ['', Validators.required],
      "bac.fecha_Pago_Primer_Cuota_Prestamo": ['', Validators.required],
      "bac.tasa_Fija_Prestamo": ['0', Validators.required],
      "bac.tasa_Variable_Prestamo": ['0', Validators.required],
      "bac.tasa_Piso_Prestamo": ['0', Validators.required],
      "bac.tasa_comision_bancaria": ['0', Validators.required],
      "bac.clausula_Construccion": [false, Validators.required],
      "bac.clausula_Septima": ['primera', Validators.required],
      "bac.clausula_comision_prepago": [false, Validators.required],
      "bac.clausula_aseguradora": [false, Validators.required],
      "bac.nombre_Fideicomiso": ['', Validators.required],
      "bac.valor_Moneda_Finca": ['', Validators.required],
      "bac.valor_Estimado_Finca": ['0', Validators.required],
      "bac.tarifa_Mensual_Fiduciario": ['0', Validators.required]
    });

    if(formIndex >= 0) this.Forms[formIndex] = this.FideicomisoGeneralForm;
  }

  ResetFideicomisoFincaForm(PreserveKey?: boolean): void {
    let formIndex = this.Forms.findIndex(x => x === this.FideicomisoFincaForm);

    this.FideicomisoFincaForm = this.formBuilder.group({
      "bac.duplicado_Finca": [
        (PreserveKey) ? this.FideicomisoFincaForm.controls['bac.duplicado_Finca'].value : '', 
        Validators.required
      ],
      "bac.horizontal_Finca": [
        (PreserveKey) ? this.FideicomisoFincaForm.controls['bac.horizontal_Finca'].value : '', 
        Validators.required
      ],
      "bac.derecho_Finca": [
        (PreserveKey) ? this.FideicomisoFincaForm.controls['bac.derecho_Finca'].value : '', 
        Validators.required
      ],
      "bac.provincia_Finca": [
        (PreserveKey) ? this.FideicomisoFincaForm.controls['bac.provincia_Finca'].value : '', 
        Validators.required
      ],
      "bac.folio_Real_Finca": [
        (PreserveKey) ? this.FideicomisoFincaForm.controls['bac.folio_Real_Finca'].value : '', 
        Validators.required
      ],
      "rnp.distrito_Finca": ['', Validators.required],
      "rnp.canton_Finca": ['', Validators.required],
      "rnp.provincia_Finca": ['', Validators.required],
      "rnp.naturaleza_Finca": ['', Validators.required],
      "rnp.linderos": ['', Validators.required],
      "rnp.metros_Cuadrados_Finca": ['', Validators.required],
      "rnp.plano_Catastro_Finca": ['', Validators.required]
    });

    if(formIndex >= 0) this.Forms[formIndex] = this.FideicomisoFincaForm;
  }

  ResetFideicomisoFiduciariaForm(PreserveKey?: boolean): void {
    let formIndex = this.Forms.findIndex(x => x === this.FideicomisoFiduciariaForm);

    this.FideicomisoFiduciariaForm = this.formBuilder.group({
      "bac.cedulajuridica_fiduciaria_Tipo": [
        (PreserveKey) ? this.FideicomisoFiduciariaForm.controls['bac.cedulajuridica_fiduciaria_Tipo'].value : '', 
        Validators.required
      ],
      "bac.cedulajuridica_fiduciaria_Clase": [
        (PreserveKey) ? this.FideicomisoFiduciariaForm.controls['bac.cedulajuridica_fiduciaria_Clase'].value : '', 
        Validators.required
      ],
      "bac.cedulajuridica_fiduciaria_Consecutivo": [
        (PreserveKey) ? this.FideicomisoFiduciariaForm.controls['bac.cedulajuridica_fiduciaria_Consecutivo'].value : '', 
        Validators.required
      ],
      "bac.cedulajuridica_fiduciaria": ['', Validators.required],
      "rnp.razon_Social_fiduciaria": ['', Validators.required],
      "bac.domicilio_fiduciaria": ['', Validators.required]
    });

    if(formIndex >= 0) this.Forms[formIndex] = this.FideicomisoFiduciariaForm;
  }

  ResetFideicomisoApoderadoForm(PreserveKey?: boolean, PreserveType?: boolean): void {
    let formIndex = this.Forms.findIndex(x => x === this.FideicomisoApoderadoForm);

    this.FideicomisoApoderadoForm = this.formBuilder.group({
      "bac.Genero_apoderado_fiduciaria": ['', Validators.required],
      "bac.Tipo_identificacion_apoderado_fiduciario": [
        (PreserveType) ? this.FideicomisoApoderadoForm.controls['bac.Tipo_identificacion_apoderado_fiduciario'].value : 'cédula de identidad', 
        Validators.required
      ],
      "bac.cedula_apoderado_fiduciaria": [
        (PreserveKey) ? this.FideicomisoApoderadoForm.controls['bac.cedula_apoderado_fiduciaria'].value : '', 
        Validators.required
      ],
      "tse.nombre_apoderado_fiduciaria": ['', Validators.required],
      "tse.nacionalidad_apoderado_fiduciaria": ['', Validators.required],
      "tse.estadocivil_apoderado_fiduciaria": ['', Validators.required],
      "bac.cantidad_estadosciviles_apoderado_fiduciaria": ['', Validators.required],
      "bac.profesion_apoderado_fiduciaria": ['', Validators.required],
      "bac.domicilio_apoderado_fiduciaria": ['', Validators.required]
    });

    if(formIndex >= 0) this.Forms[formIndex] = this.FideicomisoApoderadoForm;
  }

  ResetFideicomisoDeudorForm(PreserveKey?: boolean): void {
    let formIndex = this.Forms.findIndex(x => x === this.FideicomisoDeudorForm);
    
    this.FideicomisoDeudorForm = this.formBuilder.group({
      "bac.Genero_deudor": ['', Validators.required],
      "bac.cedula_deudor": [
        (PreserveKey) ? this.FideicomisoDeudorForm.controls['bac.cedula_deudor'].value : '', 
        Validators.required
      ],
      "tse.nombre_deudor": ['', Validators.required],
      "tse.nacionalidad_deudor": ['', Validators.required],
      "tse.estadocivil_deudor": ['', Validators.required],
      "bac.cantidad_estadosciviles_deudor": ['', Validators.required]
    });

    if(formIndex >= 0) this.Forms[formIndex] = this.FideicomisoDeudorForm;
  }

  // RESET HIPOTECA FORMS
  ResetHipotecaDeudorForm(PreserveKey?: boolean, PreserveType?: boolean): void {
    let formIndex = this.Forms.findIndex(x => x === this.HipotecaDeudorForm);

    this.HipotecaDeudorForm = this.formBuilder.group({
      "bac.Genero_deudor": ['', Validators.required],
      "bac.tipo_identificacion_deudor": [
        (PreserveType) ? this.HipotecaDeudorForm.controls['bac.tipo_identificacion_deudor'].value : 'cédula de identidad', 
        Validators.required
      ],
      "bac.cedula_deudor": [
        (PreserveKey) ? this.HipotecaDeudorForm.controls['bac.cedula_deudor'].value : '', 
        Validators.required
      ],
      "tse.nombre_deudor": ['', Validators.required],
      "tse.nacionalidad_deudor": ['', Validators.required],
      "tse.estadocivil_deudor": ['', Validators.required],
      "bac.cantidad_estadosciviles_deudor": ['', Validators.required],
      "bac.profesion_deudor": ['', Validators.required],
      "bac.domicilio_deudor": ['', Validators.required]
    });

    if(formIndex >= 0) this.Forms[formIndex] = this.HipotecaDeudorForm;
  }

  ResetHipotecaGeneralForm(): void {
    let formIndex = this.Forms.findIndex(x => x === this.HipotecaGeneralForm);

    this.HipotecaGeneralForm = this.formBuilder.group({
      "bac.monto_credito": ['0', Validators.required],
      "bac.cuotas": ['0', Validators.required],
      "bac.meses": ['0', Validators.required],
      "bac.fecha_Inicio_Prestamo": ['', Validators.required],
      "bac.fecha_Vencimiento_Prestamo": ['', Validators.required],
      "bac.fecha_Pago_Primer_Cuota_Prestamo": ['', Validators.required],
      "bac.tasafija": ['0', Validators.required],
      "bac.tasa_Variable_Prestamo": ['0', Validators.required],
      "bac.tasa_Piso_Prestamo": ['0', Validators.required],
      "bac.comision": ['0', Validators.required],
      "bac.clausula_Construccion": [false, Validators.required],
      "bac.clausula_aseguradora": [false, Validators.required],
      "bac.clausula_Septima": ['primera', Validators.required],
      "bac.clausula_comision_prepago": ['corriente', Validators.required],
      "bac.nombre_persona_asegurada": ['', Validators.required],
      "bac.grado_hipoteca": ['', Validators.required],
      "bac.traspaso_indirecta": [false, Validators.required],
      "bac.incisoB": [true, Validators.required],
      "bac.consentimiento": [true, Validators.required]
    });

    if(formIndex >= 0) this.Forms[formIndex] = this.HipotecaGeneralForm;
  }

  ResetHipotecaPropietarioForm(PreserveKey?: boolean, PreserveType?: boolean): void {
    let formIndex = this.Forms.findIndex(x => x === this.HipotecaPropietarioForm);

    this.HipotecaPropietarioForm = this.formBuilder.group({
      "bac.Genero_propietario_registral": ['', Validators.required],
      "bac.tipo_identificacion_propietario": [
        (PreserveType) ? this.HipotecaPropietarioForm.controls['bac.tipo_identificacion_propietario'].value : 'cédula de identidad', 
        Validators.required
      ],
      "bac.cedula_propietario_registral": [
        (PreserveKey) ? this.HipotecaPropietarioForm.controls['bac.cedula_propietario_registral'].value : '', 
        Validators.required
      ],
      "tse.nombre_propietario_registral": ['', Validators.required],
      "tse.nacionalidad_propietario_registral": ['', Validators.required],
      "tse.estadocivil_propietario_registral": ['', Validators.required],
      "bac.cantidad_estadosciviles_propietario_registral": ['', Validators.required],
      "bac.profesion_propietario_registral": ['', Validators.required],
      "bac.domicilio_propietario_registral": ['', Validators.required]
    });

    if(formIndex >= 0) this.Forms[formIndex] = this.HipotecaPropietarioForm;
  }

  ResetHipotecaSociedadForm(PreserveKey?: boolean, PreserveType?: boolean): void {
    let formIndex = this.Forms.findIndex(x => x === this.HipotecaSociedadForm);

    this.HipotecaSociedadForm = this.formBuilder.group({
      "bac.cedula_Sociedad_Propietario_Tipo": [
        (PreserveKey || PreserveType) ? this.HipotecaSociedadForm.controls['bac.cedula_Sociedad_Propietario_Tipo'].value : '', 
        Validators.required
      ],
      "bac.cedula_Sociedad_Propietario_Clase": [
        (PreserveKey || PreserveType) ? this.HipotecaSociedadForm.controls['bac.cedula_Sociedad_Propietario_Clase'].value : '', 
        Validators.required
      ],
      "bac.cedula_Sociedad_Propietario_Consecutivo": [
        (PreserveKey || PreserveType) ? this.HipotecaSociedadForm.controls['bac.cedula_Sociedad_Propietario_Consecutivo'].value : '', 
        Validators.required
      ],
      "bac.cedula_Sociedad_Propietario": [
        (PreserveType) ? this.HipotecaSociedadForm.controls['bac.cedula_Sociedad_Propietario'].value : '', 
        Validators.required
      ],
      "rnp.razon_Social_Sociedad_Propietario": [
        (PreserveType) ? this.HipotecaSociedadForm.controls['rnp.razon_Social_Sociedad_Propietario'].value : '', 
        Validators.required
      ],
      "bac.domicilio_Sociedad_Propietario": [
        (PreserveType) ? this.HipotecaSociedadForm.controls['bac.domicilio_Sociedad_Propietario'].value : '', 
        Validators.required
      ],
      "bac.Genero_apoderado_Propietario": [
        (PreserveType) ? this.HipotecaSociedadForm.controls['bac.Genero_apoderado_Propietario'].value : '', 
        Validators.required
      ],
      "bac.Tipo_identificacion_apoderado_Propietario": [
        (PreserveType) ? this.HipotecaSociedadForm.controls['bac.Tipo_identificacion_apoderado_Propietario'].value : 'cédula de identidad', 
        Validators.required
      ],
      "bac.cedula_apoderado_Propietario": [
        (PreserveKey) ? this.HipotecaSociedadForm.controls['bac.cedula_apoderado_Propietario'].value : '', 
        Validators.required
      ],
      "tse.nombre_apoderado_Propietario": ['', Validators.required],
      "tse.nacionalidad_apoderado_Propietario": ['', Validators.required],
      "tse.estadocivil_apoderado_Propietario": ['', Validators.required],
      "bac.cantidad_estadosciviles_apoderado_Propietario": ['', Validators.required],
      "bac.profesion_apoderado_Propietario": ['', Validators.required],
      "bac.domicilio_apoderado_Propietario": ['', Validators.required]
    });

    if(formIndex >= 0) this.Forms[formIndex] = this.HipotecaSociedadForm;
  }

  ResetHipotecaFincaForm(PreserveKey?: boolean): void {
    let formIndex = this.Forms.findIndex(x => x === this.HipotecaFincaForm);

    this.HipotecaFincaForm = this.formBuilder.group({
      "bac.duplicado_Finca": [
        (PreserveKey) ? this.HipotecaFincaForm.controls['bac.duplicado_Finca'].value : '', 
        Validators.required
      ],
      "bac.horizontal_Finca": [
        (PreserveKey) ? this.HipotecaFincaForm.controls['bac.horizontal_Finca'].value : '', 
        Validators.required
      ],
      "bac.derecho_Finca": [
        (PreserveKey) ? this.HipotecaFincaForm.controls['bac.derecho_Finca'].value : '', 
        Validators.required
      ],
      "bac.provincia_Finca": [
        (PreserveKey) ? this.HipotecaFincaForm.controls['bac.provincia_Finca'].value : '', 
        Validators.required
      ],
      "bac.folio_Real_Finca": [
        (PreserveKey) ? this.HipotecaFincaForm.controls['bac.folio_Real_Finca'].value : '', 
        Validators.required
      ],
      "rnp.distrito_Finca": ['', Validators.required],
      "rnp.canton_Finca": ['', Validators.required],
      "rnp.provincia_Finca": ['', Validators.required],
      "rnp.naturaleza_Finca": ['', Validators.required],
      "rnp.linderos": ['', Validators.required],
      "rnp.metros_Cuadrados_Finca": ['', Validators.required],
      "rnp.plano_Catastro_Finca": ['', Validators.required]
    });

    if(formIndex >= 0) this.Forms[formIndex] = this.HipotecaFincaForm;
  }
  

  // RESET PRENDAS FORMS
  ResetPrendasDeudorForm(PreserveKey?: boolean, PreserveType?: boolean): void {
    let formIndex = this.Forms.findIndex(x => x === this.PrendasDeudorForm);

    this.PrendasDeudorForm = this.formBuilder.group({
      "bac.Genero_deudor": ['', Validators.required],
      "bac.tipo_identificacion_deudor": [
        (PreserveType) ? this.PrendasDeudorForm.controls['bac.tipo_identificacion_deudor'].value : 'cédula de identidad', 
        Validators.required
      ],
      "bac.cedula_deudor": [
        (PreserveKey) ? this.PrendasDeudorForm.controls['bac.cedula_deudor'].value : '', 
        Validators.required
      ],
      "tse.nombre_deudor": ['', Validators.required],
      "tse.nacionalidad_deudor": ['', Validators.required],
      "tse.estadocivil_deudor": ['', Validators.required],
      "bac.cantidad_estadosciviles_deudor": ['', Validators.required],
      "bac.profesion_deudor": ['', Validators.required],
      "bac.domicilio_deudor": ['', Validators.required]
    });

    if(formIndex >= 0) this.Forms[formIndex] = this.PrendasDeudorForm;
  }
  ResetPrendasSociedadDeudorForm(PreserveKey?: boolean, PreserveType?: boolean): void {
    let formIndex = this.Forms.findIndex(x => x === this.PrendasSociedadDeudorForm);

    this.PrendasSociedadDeudorForm = this.formBuilder.group({
      "bac.Genero_sociedad_deudor": [
        (PreserveType) ? this.PrendasSociedadDeudorForm.controls['bac.Genero_sociedad_deudor'].value : '', 
        Validators.required
      ],
      "bac.cedula_Sociedad_Deudor_Tipo": [
        (PreserveKey || PreserveType) ? this.PrendasSociedadDeudorForm.controls['bac.cedula_Sociedad_Deudor_Tipo'].value : '', 
        Validators.required
      ],
      "bac.cedula_Sociedad_Deudor_Clase": [
        (PreserveKey || PreserveType) ? this.PrendasSociedadDeudorForm.controls['bac.cedula_Sociedad_Deudor_Clase'].value : '', 
        Validators.required
      ],
      "bac.cedula_Sociedad_Deudor_Consecutivo": [
        (PreserveKey || PreserveType) ? this.PrendasSociedadDeudorForm.controls['bac.cedula_Sociedad_Deudor_Consecutivo'].value : '', 
        Validators.required
      ],
      "bac.cedula_Sociedad_Deudor": [
        (PreserveType) ? this.PrendasSociedadDeudorForm.controls['bac.cedula_Sociedad_Deudor'].value : '', 
        Validators.required
      ],
      "rnp.razon_Social_Sociedad_Deudor": [
        (PreserveType) ? this.PrendasSociedadDeudorForm.controls['rnp.razon_Social_Sociedad_Deudor'].value : '', 
        Validators.required
      ],
      "bac.domicilio_Sociedad_Deudor": [
        (PreserveType) ? this.PrendasSociedadDeudorForm.controls['bac.domicilio_Sociedad_Deudor'].value : '', 
        Validators.required
      ],
      "bac.Genero_apoderado_deudor": [
        (PreserveType) ? this.PrendasSociedadDeudorForm.controls['bac.Genero_apoderado_deudor'].value : '', 
        Validators.required
      ],
      "bac.Tipo_identificacion_apoderado_Deudor": [
        (PreserveType) ? this.PrendasSociedadDeudorForm.controls['bac.Tipo_identificacion_apoderado_Deudor'].value : 'cédula de identidad', 
        Validators.required
      ],
      "bac.cedula_apoderado_Deudor": [
        (PreserveKey) ? this.PrendasSociedadDeudorForm.controls['bac.cedula_apoderado_Deudor'].value : '', 
        Validators.required
      ],
      "tse.nombre_apoderado_Deudor": ['', Validators.required],
      "tse.nacionalidad_apoderado_Deudor": ['', Validators.required],
      "tse.estadocivil_apoderado_Deudor": ['', Validators.required],
      "bac.cantidad_estadosciviles_apoderado_Deudor": ['', Validators.required],
      "bac.profesion_apoderado_Deudor": ['', Validators.required],
      "bac.domicilio_apoderado_Deudor": ['', Validators.required]
    });

    if(formIndex >= 0) this.Forms[formIndex] = this.PrendasSociedadDeudorForm;
  }
  ResetPrendasVendedorForm(PreserveKey?: boolean, PreserveType?: boolean): void {
    let formIndex = this.Forms.findIndex(x => x === this.PrendasVendedorForm);

    this.PrendasVendedorForm = this.formBuilder.group({
      "bac.Genero_vendedor": ['', Validators.required],
      "bac.tipo_identificacion_vendedor": [
        (PreserveType) ? this.PrendasVendedorForm.controls['bac.tipo_identificacion_vendedor'].value : this.TiposIdentificacion[0], 
        Validators.required
      ],
      "bac.cedula_vendedor": [
        (PreserveKey) ? this.PrendasVendedorForm.controls['bac.cedula_vendedor'].value : '', 
        Validators.required
      ],
      "tse.nombre_vendedor": ['', Validators.required],
      "tse.nacionalidad_vendedor": ['', Validators.required],
      "tse.estadocivil_vendedor": ['', Validators.required],
      "bac.cantidad_estadosciviles_vendedor": ['', Validators.required],
      "bac.profesion_vendedor": ['', Validators.required],
      "bac.domicilio_vendedor": ['', Validators.required]
    });

    if(formIndex >= 0) this.Forms[formIndex] = this.PrendasVendedorForm;
  }
  ResetPrendasSociedadVendedorForm(PreserveKey?: boolean, PreserveType?: boolean): void {
    let formIndex = this.Forms.findIndex(x => x === this.PrendasSociedadVendedorForm);

    this.PrendasSociedadVendedorForm = this.formBuilder.group({
      "bac.Genero_sociedad_vendedor": [
        (PreserveType) ? this.PrendasSociedadVendedorForm.controls['bac.Genero_sociedad_vendedor'].value : '', 
        Validators.required
      ],
      "bac.cedula_Sociedad_Vendedor_Tipo": [
        (PreserveKey || PreserveType) ? this.PrendasSociedadVendedorForm.controls['bac.cedula_Sociedad_Vendedor_Tipo'].value : '', 
        Validators.required
      ],
      "bac.cedula_Sociedad_Vendedor_Clase": [
        (PreserveKey || PreserveType) ? this.PrendasSociedadVendedorForm.controls['bac.cedula_Sociedad_Vendedor_Clase'].value : '', 
        Validators.required
      ],
      "bac.cedula_Sociedad_Vendedor_Consecutivo": [
        (PreserveKey || PreserveType) ? this.PrendasSociedadVendedorForm.controls['bac.cedula_Sociedad_Vendedor_Consecutivo'].value : '', 
        Validators.required
      ],
      "bac.cedula_Sociedad_Vendedor": [
        (PreserveType) ? this.PrendasSociedadVendedorForm.controls['bac.cedula_Sociedad_Vendedor'].value : '', 
        Validators.required
      ],
      "rnp.razon_Social_Sociedad_Vendedor": [
        (PreserveType) ? this.PrendasSociedadVendedorForm.controls['rnp.razon_Social_Sociedad_Vendedor'].value : '', 
        Validators.required
      ],
      "bac.domicilio_Sociedad_Vendedor": [
        (PreserveType) ? this.PrendasSociedadVendedorForm.controls['bac.domicilio_Sociedad_Vendedor'].value : '', 
        Validators.required
      ],
      "bac.Genero_apoderado_vendedor": [
        (PreserveType) ? this.PrendasSociedadVendedorForm.controls['bac.Genero_apoderado_vendedor'].value : '', 
        Validators.required
      ],
      "bac.Tipo_identificacion_apoderado_Vendedor": [
        (PreserveType) ? this.PrendasSociedadVendedorForm.controls['bac.Tipo_identificacion_apoderado_Vendedor'].value : 'cédula de identidad', 
        Validators.required
      ],
      "bac.cedula_apoderado_Vendedor": [
        (PreserveKey) ? this.PrendasSociedadVendedorForm.controls['bac.cedula_apoderado_Vendedor'].value : '', 
        Validators.required
      ],
      "tse.nombre_apoderado_Vendedor": ['', Validators.required],
      "tse.nacionalidad_apoderado_Vendedor": ['', Validators.required],
      "tse.estadocivil_apoderado_Vendedor": ['', Validators.required],
      "bac.cantidad_estadosciviles_apoderado_Vendedor": ['', Validators.required],
      "bac.profesion_apoderado_Vendedor": ['', Validators.required],
      "bac.domicilio_apoderado_Vendedor": ['', Validators.required]
    });

    if(formIndex >= 0) this.Forms[formIndex] = this.PrendasSociedadVendedorForm;
  }
  ResetPrendasCompradorForm(PreserveKey?: boolean, PreserveType?: boolean): void {
    let formIndex = this.Forms.findIndex(x => x === this.PrendasCompradorForm);

    this.PrendasCompradorForm = this.formBuilder.group({
      "bac.Genero_Comprador": ['', Validators.required],
      "bac.tipo_identificacion_Comprador": [
        (PreserveType) ? this.PrendasCompradorForm.controls['bac.tipo_identificacion_Comprador'].value : this.TiposIdentificacion[0], 
        Validators.required
      ],
      "bac.cedula_Comprador": [
        (PreserveKey) ? this.PrendasCompradorForm.controls['bac.cedula_Comprador'].value : '', 
        Validators.required
      ],
      "tse.nombre_Comprador": ['', Validators.required],
      "tse.nacionalidad_Comprador": ['', Validators.required],
      "tse.estadocivil_Comprador": ['', Validators.required],
      "bac.cantidad_estadosciviles_Comprador": ['', Validators.required],
      "bac.profesion_Comprador": ['', Validators.required],
      "bac.domicilio_Comprador": ['', Validators.required]
    });

    if(formIndex >= 0) this.Forms[formIndex] = this.PrendasCompradorForm;
  }
  ResetPrendasSociedadCompradorForm(PreserveKey?: boolean, PreserveType?: boolean): void {
    let formIndex = this.Forms.findIndex(x => x === this.PrendasSociedadCompradorForm);

    this.PrendasSociedadCompradorForm = this.formBuilder.group({
      "bac.Genero_sociedad_comprador": [
        (PreserveType) ? this.PrendasSociedadCompradorForm.controls['bac.Genero_sociedad_comprador'].value : '', 
        Validators.required
      ],
      "bac.cedula_Sociedad_Comprador_Tipo": [
        (PreserveKey || PreserveType) ? this.PrendasSociedadCompradorForm.controls['bac.cedula_Sociedad_Comprador_Tipo'].value : '', 
        Validators.required
      ],
      "bac.cedula_Sociedad_Comprador_Clase": [
        (PreserveKey || PreserveType) ? this.PrendasSociedadCompradorForm.controls['bac.cedula_Sociedad_Comprador_Clase'].value : '', 
        Validators.required
      ],
      "bac.cedula_Sociedad_Comprador_Consecutivo": [
        (PreserveKey || PreserveType) ? this.PrendasSociedadCompradorForm.controls['bac.cedula_Sociedad_Comprador_Consecutivo'].value : '', 
        Validators.required
      ],
      "bac.cedula_Sociedad_Comprador": [
        (PreserveType) ? this.PrendasSociedadCompradorForm.controls['bac.cedula_Sociedad_Comprador'].value : '', 
        Validators.required
      ],
      "rnp.razon_Social_Sociedad_Comprador": [
        (PreserveType) ? this.PrendasSociedadCompradorForm.controls['rnp.razon_Social_Sociedad_Comprador'].value : '', 
        Validators.required
      ],
      "bac.domicilio_Sociedad_Comprador": [
        (PreserveType) ? this.PrendasSociedadCompradorForm.controls['bac.domicilio_Sociedad_Comprador'].value : '', 
        Validators.required
      ],
      "bac.Genero_apoderado_comprador": [
        (PreserveType) ? this.PrendasSociedadCompradorForm.controls['bac.Genero_apoderado_comprador'].value : '', 
        Validators.required
      ],
      "bac.Tipo_identificacion_apoderado_Comprador": [
        (PreserveType) ? this.PrendasSociedadCompradorForm.controls['bac.Tipo_identificacion_apoderado_Comprador'].value : 'cédula de identidad', 
        Validators.required
      ],
      "bac.cedula_apoderado_Comprador": [
        (PreserveKey) ? this.PrendasSociedadCompradorForm.controls['bac.cedula_apoderado_Comprador'].value : '', 
        Validators.required
      ],
      "tse.nombre_apoderado_Comprador": ['', Validators.required],
      "tse.nacionalidad_apoderado_Comprador": ['', Validators.required],
      "tse.estadocivil_apoderado_Comprador": ['', Validators.required],
      "bac.cantidad_estadosciviles_apoderado_Comprador": ['', Validators.required],
      "bac.profesion_apoderado_Comprador": ['', Validators.required],
      "bac.domicilio_apoderado_Comprador": ['', Validators.required]
    });

    if(formIndex >= 0) this.Forms[formIndex] = this.PrendasSociedadCompradorForm;
  }
  ResetPrendasFiadorForm(PreserveKey?: boolean, PreserveType?: boolean): void {
    let formIndex = this.Forms.findIndex(x => x === this.PrendasFiadorForm);

    this.PrendasFiadorForm = this.formBuilder.group({
      "bac.Genero_Fiador": ['', Validators.required],
      "bac.tipo_identificacion_Fiador": [
        (PreserveType) ? this.PrendasFiadorForm.controls['bac.tipo_identificacion_Fiador'].value : this.TiposIdentificacion[0], 
        Validators.required
      ],
      "bac.cedula_Fiador": [
        (PreserveKey) ? this.PrendasFiadorForm.controls['bac.cedula_Fiador'].value : '', 
        Validators.required
      ],
      "tse.nombre_Fiador": ['', Validators.required],
      "tse.nacionalidad_Fiador": ['', Validators.required],
      "tse.estadocivil_Fiador": ['', Validators.required],
      "bac.cantidad_estadosciviles_Fiador": ['', Validators.required],
      "bac.profesion_Fiador": ['', Validators.required],
      "bac.domicilio_Fiador": ['', Validators.required]
    });

    if(formIndex >= 0) this.Forms[formIndex] = this.PrendasFiadorForm;
  }
  ResetPrendasGeneralForm(): void {
    let formIndex = this.Forms.findIndex(x => x === this.PrendasGeneralForm);

    this.PrendasGeneralForm = this.formBuilder.group({
      "bac.nombre_Prenda": ['', Validators.required],
      "bac.monto_prima": ['', Validators.required],
      "bac.banco_vendedor": ['', Validators.required],
      "bac.cuenta_vendedor": ['', Validators.required],
      "bac.origen_fondos": ['', Validators.required],
      "bac.banco_comprador": ['', Validators.required],
      "bac.cuenta_comprador": ['', Validators.required],
      "bac.monto_credito": ['0', Validators.required],
      "bac.cuotas": ['0', Validators.required],
      "bac.meses": ['0', Validators.required],
      "bac.fecha_Inicio_Prenda": ['', Validators.required],
      "bac.fecha_Pago_Primer_Cuota_Prenda": ['', Validators.required],
      "bac.fecha_Vencimiento_Prenda": ['', Validators.required],
      "bac.plazo_tasafija": ['', Validators.required],
      "bac.tasafija": ['0', Validators.required],
      "bac.tasa_Variable_Prestamo": ['0', Validators.required],
      "bac.tasa_Piso_Prestamo": ['0', Validators.required],
      "bac.comision": ['0', Validators.required],
      "bac.grado_prenda": ['', Validators.required],
      "bac.fecha_firma": ['', Validators.required],
      "bac.compra_venta": [false, Validators.required],
      "bac.Comision_Bancaria": [false, Validators.required],
      "bac.Pasivos": [false, Validators.required],
      "bac.check_Tasa_Variable": [false, Validators.required],
      "bac.check_fiador": [false, Validators.required],
      "bac.consentimiento": [false, Validators.required],
    });

    if(formIndex >= 0) this.Forms[formIndex] = this.PrendasGeneralForm;
  }
  /**
   * Resetea el formulario de vehiculos en el formato de prendas y lo actualiza en la lista de formularios
   * @param PreserveKey Indica si el reseteo actualiza los campos de busqueda o llaves
   */
  ResetPrendasVehiculoForm(PreserveKey?: boolean): void {
    let formIndex = this.Forms.findIndex(x => x === this.PrendasVehiculoForm);

    this.PrendasVehiculoForm = this.formBuilder.group({
      "bac.clase_vehiculo": [
        (PreserveKey) ? this.PrendasVehiculoForm.controls['bac.clase_vehiculo'].value : ' ', 
        Validators.required
      ],
      "bac.codigo_vehiculo": [
        (PreserveKey) ? this.PrendasVehiculoForm.controls['bac.codigo_vehiculo'].value : '', 
        Validators.required
      ],
      "bac.numero_placa": [
        (PreserveKey) ? this.PrendasVehiculoForm.controls['bac.numero_placa'].value : '', 
        Validators.required
      ],
      "rnp.numero_placa": ['', Validators.required],
      "rnp.identificacion_propietario": ['', Validators.required],
      "rnp.nombre_propietario": ['', Validators.required],
      "rnp.marca_vehiculo": ['', Validators.required],
      "rnp.estilo": ['', Validators.required],
      "rnp.categoria": ['', Validators.required],
      "rnp.capacidad": ['', Validators.required],
      "rnp.serie": ['', Validators.required],
      "rnp.chasis": ['', Validators.required],
      "rnp.vin": ['', Validators.required],
      "rnp.carroceria": ['', Validators.required],
      "rnp.traccion": ['', Validators.required],
      "rnp.peso_bruto": ['', Validators.required],
      "rnp.anio_fabricacion": ['', Validators.required],
      "rnp.uso": ['', Validators.required],
      "rnp.color": ['', Validators.required],
      "rnp.numero_motor": ['', Validators.required],
      "rnp.marca_motor": ['', Validators.required],
      "rnp.combustible": ['', Validators.required],
      "rnp.cilindrada": ['', Validators.required],
      "rnp.potencia": ['', Validators.required],
      "rnp.cilindros": ['', Validators.required]
    });

    // Preselected - Particulas, this instruction is necessary to load the codes array
    this.UpdateCodes(PreserveKey);

    if(formIndex >= 0) this.Forms[formIndex] = this.PrendasVehiculoForm;
  }


  // LOAD FIDEICOMISO DATA
  /**
   * Carga desde el sitio del TSE los datos de una persona para el formulario fideicomitente cesionario
   */
  CargarTSECesionario(): void {
    if(this.FideicomisoCesionarioForm.controls["bac.tipo_identificacion_Fideicomitente_Cesionario"].value !== this.TiposIdentificacion[0]){
      return;
    }
    if(!this.FideicomisoCesionarioForm.controls["bac.cedula_Firmante_Fideicomitente_Cesionario"].value){
      return;
    }
    if(!this.FideicomisoCesionarioForm.controls["bac.Genero_fideicomitente_cesionario"].value){
      this.alertsService.ShowBigCenteredAlert("Debe seleccionar el género antes de realizar la búsqueda", ALERTS.warning)
      return;
    }
    this.blockUiHanddler.Start(1, "Buscando cédula...");
    this.templatesService.GetDataTSE(this.FideicomisoCesionarioForm.controls["bac.cedula_Firmante_Fideicomitente_Cesionario"].value).subscribe(req => {
      if (req.Result) {
        this.blockUiHanddler.Stop()
        this.FideicomisoCesionarioForm.controls["tse.nombre_Firmante_Fideicomitente_Cesionario"].setValue(req.Data.Name);
        this.FideicomisoCesionarioForm.controls["tse.nacionalidad_Firmante_Fideicomitente_Cesionario"].setValue(req.Data.Nationality.toLowerCase()); 
        this.FideicomisoCesionarioForm.controls["tse.estadocivil_Firmante_Fideicomitente_Cesionario"].setValue(this.GenerateGenderWord(req.Data.CivilStatus.toLowerCase(), this.FideicomisoCesionarioForm.controls["bac.Genero_fideicomitente_cesionario"].value));
      } else {
        this.ResetFideicomisoCesionarioForm(true, true);
        this.alertsService.ShowBigCenteredAlert(req.ErrorInfo.Message, ALERTS.error);
        this.blockUiHanddler.Stop();
      }
    }, err => {
      this.ResetFideicomisoCesionarioForm(true, true);
      this.alertsService.ShowSmallCornerAlert(err, ALERTS.error);
      this.blockUiHanddler.Stop();
    });
  }
  /**
   * Carga desde el sitio del TSE los datos de una persona para el formulario fideicomitente original
   */
  CargarTSEOriginal() {
    if(this.FideicomisoOriginalForm.controls["bac.tipo_identificacion_Fideicomitente_Original"].value !== this.TiposIdentificacion[0]){
      return;
    }
    if(!this.FideicomisoOriginalForm.controls["bac.cedula_Fideicomitente_Original"].value){
      return;
    }
    if(!this.FideicomisoOriginalForm.controls["bac.Genero_fideicomitente_original"].value){
      this.alertsService.ShowBigCenteredAlert("Debe seleccionar el género antes de realizar la búsqueda", ALERTS.warning)
      return;
    }
    this.blockUiHanddler.Start(1, "Buscando cédula...");
    this.templatesService.GetDataTSE(this.FideicomisoOriginalForm.controls["bac.cedula_Fideicomitente_Original"].value).subscribe(req => {
      if (req.Result) {
        this.blockUiHanddler.Stop()
        this.FideicomisoOriginalForm.controls["tse.nombre_Firmante_Fideicomitente_Original"].setValue(req.Data.Name)
        this.FideicomisoOriginalForm.controls["tse.nacionalidad_Firmante_Fideicomitente_Original"].setValue(req.Data.Nationality.toLowerCase())
        this.FideicomisoOriginalForm.controls["tse.estadocivil_Firmante_Fideicomitente_Original"].setValue(this.GenerateGenderWord(req.Data.CivilStatus.toLowerCase(), this.FideicomisoOriginalForm.controls["bac.Genero_fideicomitente_original"].value));
      } else {
        this.ResetFideicomisoOriginalForm(true);
        this.alertsService.ShowBigCenteredAlert(req.ErrorInfo.Message, ALERTS.error);
        this.blockUiHanddler.Stop();
      }
    }, err => {
      this.ResetFideicomisoOriginalForm(true);
      this.alertsService.ShowSmallCornerAlert(err, ALERTS.error);
      this.blockUiHanddler.Stop();
    });
  }
  /**
   * Carga desde el sitio del TSE los datos de una persona para el formulario fideicomitente apoderado original
   */
  CargarTSEApoderadoOriginal() {
    if(this.FideicomisoSociedadForm.controls["bac.Tipo_identificacion_apoderado_fideicomitente_original"].value !== this.TiposIdentificacion[0]){
      return;
    }
    if(!this.FideicomisoSociedadForm.controls["bac.cedula_apoderado_fideicomitente_original"].value){
      return;
    }
    if(!this.FideicomisoSociedadForm.controls["bac.Genero_apoderado_fideicomitente_original"].value){
      this.alertsService.ShowBigCenteredAlert("Debe seleccionar el género antes de realizar la búsqueda", ALERTS.warning)
      return;
    }
    this.blockUiHanddler.Start(1, "Buscando cédula...");
    this.templatesService.GetDataTSE(this.FideicomisoSociedadForm.controls["bac.cedula_apoderado_fideicomitente_original"].value).subscribe(req => {
      if (req.Result) {
        this.blockUiHanddler.Stop();
        this.FideicomisoSociedadForm.controls["tse.nombre_apoderado_fideicomitente_original"].setValue(req.Data.Name);
        this.FideicomisoSociedadForm.controls["tse.nacionalidad_apoderado_fideicomitente_original"].setValue(req.Data.Nationality.toLowerCase());
        this.FideicomisoSociedadForm.controls["tse.estadocivil_apoderado_fideicomitente_original"].setValue(this.GenerateGenderWord(req.Data.CivilStatus.toLowerCase(),this.FideicomisoSociedadForm.controls["bac.Genero_apoderado_fideicomitente_original"].value));
      } else {
        this.ResetFideicomisoSociedadForm(true, true);
        this.alertsService.ShowBigCenteredAlert(req.ErrorInfo.Message, ALERTS.error);
        this.blockUiHanddler.Stop();
      }
    }, err => {
      this.ResetFideicomisoSociedadForm(true, true);
      this.alertsService.ShowSmallCornerAlert(err, ALERTS.error);
      this.blockUiHanddler.Stop();
    });
  }
  
  CargarRNSociedad() {
    if (this.FideicomisoSociedadForm.controls["bac.cedula_Sociedad_Fideicomitente_Original_Tipo"].value &&
      this.FideicomisoSociedadForm.controls["bac.cedula_Sociedad_Fideicomitente_Original_Clase"].value &&
      this.FideicomisoSociedadForm.controls["bac.cedula_Sociedad_Fideicomitente_Original_Consecutivo"].value) {
      this.blockUiHanddler.Start(1, "Buscando cédula jurídica...")
      
      this.templatesService.GetDataRNPersonaJuridica(
        this.ActiveUser.Id,
        this.FideicomisoSociedadForm.controls["bac.cedula_Sociedad_Fideicomitente_Original_Tipo"].value,
        this.FideicomisoSociedadForm.controls["bac.cedula_Sociedad_Fideicomitente_Original_Clase"].value,
        this.FideicomisoSociedadForm.controls["bac.cedula_Sociedad_Fideicomitente_Original_Consecutivo"].value).subscribe(req => {
          this.blockUiHanddler.Stop()
          if (req.Result) {
            if(req.Data.BussinessName){
              this.FideicomisoSociedadForm.controls["bac.cedula_Sociedad_Fideicomitente_Original"].setValue(req.Data.BussinessCard);
              this.FideicomisoSociedadForm.controls["rnp.razon_Social_Sociedad_Fideicomitente_Original"].setValue(req.Data.BussinessName);
            } else {
              this.ResetFideicomisoSociedadForm(true);
              this.alertsService.ShowSmallCornerAlert("No se encontró la cédula jurídica", ALERTS.warning)
            }
          } else {
            this.ResetFideicomisoSociedadForm(true);
            this.alertsService.ShowBigCenteredAlert(req.ErrorInfo.Message, ALERTS.error)
          }
        }, err => {
          this.ResetFideicomisoSociedadForm(true);
          this.alertsService.ShowBigCenteredAlert(err, ALERTS.error)
          this.blockUiHanddler.Stop()
        });
    }
  }

  CargarRNFinca() {
    if (this.FideicomisoFincaForm.controls["bac.provincia_Finca"].value &&
      this.FideicomisoFincaForm.controls["bac.folio_Real_Finca"].value) {

      this.blockUiHanddler.Start(1, "Buscando finca...");
      this.templatesService.GetDataRNFinca(
        this.ActiveUser.Id,
        this.FideicomisoFincaForm.controls["bac.folio_Real_Finca"].value,
        this.FideicomisoFincaForm.controls["bac.provincia_Finca"].value,
        this.FideicomisoFincaForm.controls["bac.duplicado_Finca"].value,
        this.FideicomisoFincaForm.controls["bac.horizontal_Finca"].value,
        this.FideicomisoFincaForm.controls["bac.derecho_Finca"].value
        ).subscribe(req => {
          this.blockUiHanddler.Stop();
          if (req.Result) {
            if(req.Data.Provincia){
              this.FideicomisoFincaForm.controls["rnp.distrito_Finca"].setValue(req.Data.Distrito);
              this.FideicomisoFincaForm.controls["rnp.canton_Finca"].setValue(req.Data.Canton);
              this.FideicomisoFincaForm.controls["rnp.provincia_Finca"].setValue(req.Data.Provincia);
              this.FideicomisoFincaForm.controls["rnp.naturaleza_Finca"].setValue(req.Data.Nature);
              this.FideicomisoFincaForm.controls["rnp.linderos"].setValue(req.Data.Edges);
              this.FideicomisoFincaForm.controls["rnp.metros_Cuadrados_Finca"].setValue(req.Data.Size);
              this.FideicomisoFincaForm.controls["rnp.plano_Catastro_Finca"].setValue(req.Data.Plan);
            } else {
              this.ResetFideicomisoFincaForm(true);
              this.alertsService.ShowSmallCornerAlert("No se encontró la finca", ALERTS.warning);
            }
          } else {
            this.ResetFideicomisoFincaForm(true);
            this.alertsService.ShowBigCenteredAlert(req.ErrorInfo.Message, ALERTS.error);
          }
        }, err => {
          this.ResetFideicomisoFincaForm(true);
          this.alertsService.ShowBigCenteredAlert(err, ALERTS.error);
          this.blockUiHanddler.Stop();
        });
      }
  }

  CargarRNFiduciaria() {
    if (this.FideicomisoFiduciariaForm.controls["bac.cedulajuridica_fiduciaria_Tipo"].value &&
      this.FideicomisoFiduciariaForm.controls["bac.cedulajuridica_fiduciaria_Clase"].value &&
      this.FideicomisoFiduciariaForm.controls["bac.cedulajuridica_fiduciaria_Consecutivo"].value) {
      this.blockUiHanddler.Start(1, "Buscando cédula jurídica...")
      
      this.templatesService.GetDataRNPersonaJuridica(
        this.ActiveUser.Id,
        this.FideicomisoFiduciariaForm.controls["bac.cedulajuridica_fiduciaria_Tipo"].value,
        this.FideicomisoFiduciariaForm.controls["bac.cedulajuridica_fiduciaria_Clase"].value,
        this.FideicomisoFiduciariaForm.controls["bac.cedulajuridica_fiduciaria_Consecutivo"].value).subscribe(req => {
          this.blockUiHanddler.Stop()
          if (req.Result) {
            if(req.Data.BussinessName){
              this.FideicomisoFiduciariaForm.controls["bac.cedulajuridica_fiduciaria"].setValue(req.Data.BussinessCard);
              this.FideicomisoFiduciariaForm.controls["rnp.razon_Social_fiduciaria"].setValue(req.Data.BussinessName);
            } else {
              this.ResetFideicomisoFiduciariaForm(true);
              this.alertsService.ShowSmallCornerAlert("No se encontró la cédula jurídica", ALERTS.warning);
            }
          } else {
            this.ResetFideicomisoFiduciariaForm(true);
            this.alertsService.ShowBigCenteredAlert(req.ErrorInfo.Message, ALERTS.error);
          }
        }, err => {
          this.ResetFideicomisoFiduciariaForm(true);
          this.alertsService.ShowBigCenteredAlert(err, ALERTS.error);
          this.blockUiHanddler.Stop()
        });
    }
  }
  /**
   * Carga desde el sitio del TSE los datos de una persona para el formulario apoderado fiduciario
   */
  CargarTSEApoderado() {
    if(this.FideicomisoApoderadoForm.controls["bac.Tipo_identificacion_apoderado_fiduciario"].value !== this.TiposIdentificacion[0]){
      return;
    }
    if(!this.FideicomisoApoderadoForm.controls["bac.cedula_apoderado_fiduciaria"].value){
      return;
    }
    if(!this.FideicomisoApoderadoForm.controls["bac.Genero_apoderado_fiduciaria"].value){
      this.alertsService.ShowBigCenteredAlert("Debe seleccionar el género antes de realizar la búsqueda", ALERTS.warning)
      return;
    }
    this.blockUiHanddler.Start(1, "Buscando cédula...")
    this.templatesService.GetDataTSE(this.FideicomisoApoderadoForm.controls["bac.cedula_apoderado_fiduciaria"].value).subscribe(req => {
      if (req.Result) {
        this.blockUiHanddler.Stop()
        this.FideicomisoApoderadoForm.controls["tse.nombre_apoderado_fiduciaria"].setValue(req.Data.Name);
        this.FideicomisoApoderadoForm.controls["tse.nacionalidad_apoderado_fiduciaria"].setValue(req.Data.Nationality.toLowerCase());
        this.FideicomisoApoderadoForm.controls["tse.estadocivil_apoderado_fiduciaria"].setValue(this.GenerateGenderWord(req.Data.CivilStatus.toLowerCase(), this.FideicomisoApoderadoForm.controls["bac.Genero_apoderado_fiduciaria"].value));
      } else {
        this.ResetFideicomisoApoderadoForm(true);
        this.alertsService.ShowBigCenteredAlert(req.ErrorInfo.Message, ALERTS.error)
        this.blockUiHanddler.Stop()
      }
    }, err => {
      this.ResetFideicomisoApoderadoForm(true);
      this.alertsService.ShowSmallCornerAlert(err, ALERTS.error)
      this.blockUiHanddler.Stop()
    });
  }
  /**
   * Carga desde el sitio del TSE los datos de una persona para el formulario fideicomiso deudor
   */
  CargarTSEDeudor() {
    if(!this.FideicomisoDeudorForm.controls["bac.cedula_deudor"].value){
      return;
    }
    if(!this.FideicomisoDeudorForm.controls["bac.Genero_deudor"].value){
      this.alertsService.ShowBigCenteredAlert("Debe seleccionar el género antes de realizar la búsqueda", ALERTS.warning)
      return;
    }
    this.blockUiHanddler.Start(1, "Buscando cédula...");
    this.templatesService.GetDataTSE(this.FideicomisoDeudorForm.controls["bac.cedula_deudor"].value).subscribe(req => {
      if (req.Result) {
        this.blockUiHanddler.Stop();
        this.FideicomisoDeudorForm.controls["tse.nombre_deudor"].setValue(req.Data.Name);
        this.FideicomisoDeudorForm.controls["tse.nacionalidad_deudor"].setValue(req.Data.Nationality.toLowerCase());
        this.FideicomisoDeudorForm.controls["tse.estadocivil_deudor"].setValue(this.GenerateGenderWord(req.Data.CivilStatus.toLowerCase(), this.FideicomisoDeudorForm.controls["bac.Genero_deudor"].value));
      } else {
        this.ResetFideicomisoDeudorForm(true);
        this.alertsService.ShowBigCenteredAlert(req.ErrorInfo.Message, ALERTS.error);
        this.blockUiHanddler.Stop();
      }
    }, err => {
      this.ResetFideicomisoDeudorForm(true);
      this.alertsService.ShowSmallCornerAlert(err, ALERTS.error);
      this.blockUiHanddler.Stop();
    });
  }

  // LOAD HIPOTECA DATA
  /**
   * Carga desde el sitio del TSE los datos de una persona para el formulario hipoteca deudor
   */
  CargarTSEHipotecaDeudor() {
    if(this.HipotecaDeudorForm.controls["bac.tipo_identificacion_deudor"].value !== this.TiposIdentificacion[0]){
      return;
    }
    if(!this.HipotecaDeudorForm.controls["bac.cedula_deudor"].value){
      return;
    }
    if(!this.HipotecaDeudorForm.controls["bac.Genero_deudor"].value){
      this.alertsService.ShowBigCenteredAlert("Debe seleccionar el género antes de realizar la búsqueda", ALERTS.warning)
      return;
    }
    this.blockUiHanddler.Start(1, "Buscando cédula...")
    this.templatesService.GetDataTSE(this.HipotecaDeudorForm.controls["bac.cedula_deudor"].value).subscribe(req => {
      if (req.Result) {
        this.blockUiHanddler.Stop()
        this.HipotecaDeudorForm.controls["tse.nombre_deudor"].setValue(req.Data.Name);
        this.HipotecaDeudorForm.controls["tse.nacionalidad_deudor"].setValue(req.Data.Nationality.toLowerCase());
        this.HipotecaDeudorForm.controls["tse.estadocivil_deudor"].setValue(this.GenerateGenderWord(req.Data.CivilStatus.toLowerCase(), this.HipotecaDeudorForm.controls["bac.Genero_deudor"].value));
      } else {
        this.ResetHipotecaDeudorForm(true, true);
        this.alertsService.ShowBigCenteredAlert(req.ErrorInfo.Message, ALERTS.error);
        this.blockUiHanddler.Stop();
      }
    }, err => {
      this.ResetHipotecaDeudorForm(true, true);
      this.alertsService.ShowSmallCornerAlert(err, ALERTS.error);
      this.blockUiHanddler.Stop();
    });
  }
  /**
   * Carga desde el sitio del TSE los datos de una persona para el formulario hipoteca propietario
   */
  CargarTSEHipotecaPropietario() {
    if(this.HipotecaPropietarioForm.controls["bac.tipo_identificacion_propietario"].value !== this.TiposIdentificacion[0]){
      return;
    }
    if(!this.HipotecaPropietarioForm.controls["bac.cedula_propietario_registral"].value){
      return;
    }
    if(!this.HipotecaPropietarioForm.controls["bac.Genero_propietario_registral"].value){
      this.alertsService.ShowBigCenteredAlert("Debe seleccionar el género antes de realizar la búsqueda", ALERTS.warning)
      return;
    }
    this.blockUiHanddler.Start(1, "Buscando cédula...")
    this.templatesService.GetDataTSE(this.HipotecaPropietarioForm.controls["bac.cedula_propietario_registral"].value).subscribe(req => {
      if (req.Result) {
        this.blockUiHanddler.Stop()
        this.HipotecaPropietarioForm.controls["tse.nombre_propietario_registral"].setValue(req.Data.Name);
        this.HipotecaPropietarioForm.controls["tse.nacionalidad_propietario_registral"].setValue(req.Data.Nationality.toLowerCase());
        this.HipotecaPropietarioForm.controls["tse.estadocivil_propietario_registral"].setValue(this.GenerateGenderWord(req.Data.CivilStatus.toLowerCase(), this.HipotecaPropietarioForm.controls["bac.Genero_propietario_registral"].value));
      } else {
        this.ResetHipotecaPropietarioForm(true, true);
        this.alertsService.ShowBigCenteredAlert(req.ErrorInfo.Message, ALERTS.error);
        this.blockUiHanddler.Stop();
      }
    }, err => {
      this.ResetHipotecaPropietarioForm(true, true);
      this.alertsService.ShowSmallCornerAlert(err, ALERTS.error);
      this.blockUiHanddler.Stop();
    });
  }

  CargarRNSociedadPropietario() {
    if (this.HipotecaSociedadForm.controls["bac.cedula_Sociedad_Propietario_Tipo"].value &&
      this.HipotecaSociedadForm.controls["bac.cedula_Sociedad_Propietario_Clase"].value &&
      this.HipotecaSociedadForm.controls["bac.cedula_Sociedad_Propietario_Consecutivo"].value) {
      this.blockUiHanddler.Start(1, "Buscando cédula jurídica...")
      
      this.templatesService.GetDataRNPersonaJuridica(
        this.ActiveUser.Id,
        this.HipotecaSociedadForm.controls["bac.cedula_Sociedad_Propietario_Tipo"].value,
        this.HipotecaSociedadForm.controls["bac.cedula_Sociedad_Propietario_Clase"].value,
        this.HipotecaSociedadForm.controls["bac.cedula_Sociedad_Propietario_Consecutivo"].value).subscribe(req => {
          this.blockUiHanddler.Stop()
          if (req.Result) {
            if(req.Data.BussinessName){
              this.HipotecaSociedadForm.controls["bac.cedula_Sociedad_Propietario"].setValue(req.Data.BussinessCard);
              this.HipotecaSociedadForm.controls["rnp.razon_Social_Sociedad_Propietario"].setValue(req.Data.BussinessName);
            } else {
              this.ResetHipotecaSociedadForm(true);
              this.alertsService.ShowSmallCornerAlert("No se encontró la cédula jurídica", ALERTS.warning)
            }
          } else {
            this.ResetHipotecaSociedadForm(true);
            this.alertsService.ShowBigCenteredAlert(req.ErrorInfo.Message, ALERTS.error)
          }
        }, err => {
          this.ResetHipotecaSociedadForm(true);
          this.alertsService.ShowBigCenteredAlert(err, ALERTS.error)
          this.blockUiHanddler.Stop()
        });
    }
  }
  /**
   * Carga desde el sitio del TSE los datos de una persona para el formulario apoderado propietario
   */
  CargarTSEApoderadoPropietario() {
    if(this.HipotecaSociedadForm.controls["bac.Tipo_identificacion_apoderado_Propietario"].value !== this.TiposIdentificacion[0]){
      return;
    }
    if(!this.HipotecaSociedadForm.controls["bac.cedula_apoderado_Propietario"].value){
      return;
    }
    if(!this.HipotecaSociedadForm.controls["bac.Genero_apoderado_Propietario"].value){
      this.alertsService.ShowBigCenteredAlert("Debe seleccionar el género antes de realizar la búsqueda", ALERTS.warning)
      return;
    }
    this.blockUiHanddler.Start(1, "Buscando cédula...");
    this.templatesService.GetDataTSE(this.HipotecaSociedadForm.controls["bac.cedula_apoderado_Propietario"].value).subscribe(req => {
      if (req.Result) {
        this.blockUiHanddler.Stop();
        this.HipotecaSociedadForm.controls["tse.nombre_apoderado_Propietario"].setValue(req.Data.Name);
        this.HipotecaSociedadForm.controls["tse.nacionalidad_apoderado_Propietario"].setValue(req.Data.Nationality.toLowerCase());
        this.HipotecaSociedadForm.controls["tse.estadocivil_apoderado_Propietario"].setValue(this.GenerateGenderWord(req.Data.CivilStatus.toLowerCase(), this.HipotecaSociedadForm.controls["bac.Genero_apoderado_Propietario"].value));
      } else {
        this.ResetHipotecaSociedadForm(true, true);
        this.alertsService.ShowBigCenteredAlert(req.ErrorInfo.Message, ALERTS.error);
        this.blockUiHanddler.Stop();
      }
    }, err => {
      this.ResetHipotecaSociedadForm(true, true);
      this.alertsService.ShowSmallCornerAlert(err, ALERTS.error);
      this.blockUiHanddler.Stop();
    });
  }

  CargarRNHipotecaFinca() {
    if (this.HipotecaFincaForm.controls["bac.provincia_Finca"].value &&
      this.HipotecaFincaForm.controls["bac.folio_Real_Finca"].value) {

      this.blockUiHanddler.Start(1, "Buscando finca...");
      this.templatesService.GetDataRNFinca(
        this.ActiveUser.Id,
        this.HipotecaFincaForm.controls["bac.folio_Real_Finca"].value,
        this.HipotecaFincaForm.controls["bac.provincia_Finca"].value,
        this.HipotecaFincaForm.controls["bac.duplicado_Finca"].value,
        this.HipotecaFincaForm.controls["bac.horizontal_Finca"].value,
        this.HipotecaFincaForm.controls["bac.derecho_Finca"].value
        ).subscribe(req => {
          this.blockUiHanddler.Stop();
          if (req.Result) {
            if(req.Data.Provincia){
              this.HipotecaFincaForm.controls["rnp.distrito_Finca"].setValue(req.Data.Distrito);
              this.HipotecaFincaForm.controls["rnp.canton_Finca"].setValue(req.Data.Canton);
              this.HipotecaFincaForm.controls["rnp.provincia_Finca"].setValue(req.Data.Provincia);
              this.HipotecaFincaForm.controls["rnp.naturaleza_Finca"].setValue(req.Data.Nature);
              this.HipotecaFincaForm.controls["rnp.linderos"].setValue(req.Data.Edges);
              this.HipotecaFincaForm.controls["rnp.metros_Cuadrados_Finca"].setValue(req.Data.Size);
              this.HipotecaFincaForm.controls["rnp.plano_Catastro_Finca"].setValue(req.Data.Plan);
            } else {
              this.ResetHipotecaFincaForm(true);
              this.alertsService.ShowSmallCornerAlert("No se encontró la finca", ALERTS.warning);
            }
          } else {
            this.ResetHipotecaFincaForm(true);
            this.alertsService.ShowBigCenteredAlert(req.ErrorInfo.Message, ALERTS.error);
          }
        }, err => {
          this.ResetHipotecaFincaForm(true);
          this.alertsService.ShowBigCenteredAlert(err, ALERTS.error);
          this.blockUiHanddler.Stop();
        });
      }
  }

  // LOAD PRENDAS DATA
  /**
   * Carga desde el sitio del TSE los datos de una persona para el formulario prendas deudor
   */
  CargarTSEPrendasDeudor() {
    if(this.PrendasDeudorForm.controls["bac.tipo_identificacion_deudor"].value !== this.TiposIdentificacion[0]){
      return;
    }
    if(!this.PrendasDeudorForm.controls["bac.cedula_deudor"].value){
      return;
    }
    if(!this.PrendasDeudorForm.controls["bac.Genero_deudor"].value){
      this.alertsService.ShowBigCenteredAlert("Debe seleccionar el género antes de realizar la búsqueda", ALERTS.warning)
      return;
    }
    this.blockUiHanddler.Start(1, "Buscando cédula...")
    this.templatesService.GetDataTSE(this.PrendasDeudorForm.controls["bac.cedula_deudor"].value).subscribe(req => {
      if (req.Result) {
        this.blockUiHanddler.Stop()
        this.PrendasDeudorForm.controls["tse.nombre_deudor"].setValue(req.Data.Name);
        this.PrendasDeudorForm.controls["tse.nacionalidad_deudor"].setValue(req.Data.Nationality.toLowerCase());
        this.PrendasDeudorForm.controls["tse.estadocivil_deudor"].setValue(this.GenerateGenderWord(req.Data.CivilStatus.toLowerCase(), this.PrendasDeudorForm.controls["bac.Genero_deudor"].value));
      } else {
        this.ResetPrendasDeudorForm(true, true);
        this.alertsService.ShowBigCenteredAlert(req.ErrorInfo.Message, ALERTS.error);
        this.blockUiHanddler.Stop();
      }
    }, err => {
      this.ResetPrendasDeudorForm(true, true);
      this.alertsService.ShowSmallCornerAlert(err, ALERTS.error);
      this.blockUiHanddler.Stop();
    });
  }
  CargarRNPrendasSociedadDeudor() {
    if (this.PrendasSociedadDeudorForm.controls["bac.cedula_Sociedad_Deudor_Tipo"].value &&
      this.PrendasSociedadDeudorForm.controls["bac.cedula_Sociedad_Deudor_Clase"].value &&
      this.PrendasSociedadDeudorForm.controls["bac.cedula_Sociedad_Deudor_Consecutivo"].value) {
      this.blockUiHanddler.Start(1, "Buscando cédula jurídica...")
      
      this.templatesService.GetDataRNPersonaJuridica(
        this.ActiveUser.Id,
        this.PrendasSociedadDeudorForm.controls["bac.cedula_Sociedad_Deudor_Tipo"].value,
        this.PrendasSociedadDeudorForm.controls["bac.cedula_Sociedad_Deudor_Clase"].value,
        this.PrendasSociedadDeudorForm.controls["bac.cedula_Sociedad_Deudor_Consecutivo"].value).subscribe(req => {
          this.blockUiHanddler.Stop()
          if (req.Result) {
            if(req.Data.BussinessName){
              this.PrendasSociedadDeudorForm.controls["bac.cedula_Sociedad_Deudor"].setValue(req.Data.BussinessCard);
              this.PrendasSociedadDeudorForm.controls["rnp.razon_Social_Sociedad_Deudor"].setValue(req.Data.BussinessName);
            } else {
              this.ResetPrendasSociedadDeudorForm(true);
              this.alertsService.ShowBigCenteredAlert(req.ErrorInfo.Message, ALERTS.error)
            }
          } else {
            this.ResetPrendasSociedadDeudorForm(true);
            this.alertsService.ShowBigCenteredAlert(req.ErrorInfo.Message, ALERTS.error)
          }
        }, err => {
          this.ResetPrendasSociedadDeudorForm(true);
          this.alertsService.ShowBigCenteredAlert(err, ALERTS.error)
          this.blockUiHanddler.Stop()
        });
    }
  }
  /**
   * Carga desde el sitio del TSE los datos de una persona para el formulario apoderado deudor
   */
  CargarTSEPrendasApoderadoDeudor() {
    if(this.PrendasSociedadDeudorForm.controls["bac.Tipo_identificacion_apoderado_Deudor"].value !== this.TiposIdentificacion[0]){
      return;
    }
    if(!this.PrendasSociedadDeudorForm.controls["bac.cedula_apoderado_Deudor"].value){
      return;
    }
    if(!this.PrendasSociedadDeudorForm.controls["bac.Genero_apoderado_deudor"].value){
      this.alertsService.ShowBigCenteredAlert("Debe seleccionar el género antes de realizar la búsqueda", ALERTS.warning)
      return;
    }
    this.blockUiHanddler.Start(1, "Buscando cédula...")
    this.templatesService.GetDataTSE(this.PrendasSociedadDeudorForm.controls["bac.cedula_apoderado_Deudor"].value).subscribe(req => {
      if (req.Result) {
        this.blockUiHanddler.Stop()
        this.PrendasSociedadDeudorForm.controls["tse.nombre_apoderado_Deudor"].setValue(req.Data.Name);
        this.PrendasSociedadDeudorForm.controls["tse.nacionalidad_apoderado_Deudor"].setValue(req.Data.Nationality.toLowerCase());
        this.PrendasSociedadDeudorForm.controls["tse.estadocivil_apoderado_Deudor"].setValue(this.GenerateGenderWord(req.Data.CivilStatus.toLowerCase(), this.PrendasSociedadDeudorForm.controls["bac.Genero_apoderado_deudor"].value));
      } else {
        this.ResetPrendasSociedadDeudorForm(true);
        this.alertsService.ShowBigCenteredAlert(req.ErrorInfo.Message, ALERTS.error);
        this.blockUiHanddler.Stop();
      }
    }, err => {
      this.ResetPrendasSociedadDeudorForm(true);
      this.alertsService.ShowSmallCornerAlert(err, ALERTS.error);
      this.blockUiHanddler.Stop();
    });
  }
  /**
   * Carga desde el sitio del TSE los datos de una persona para el formulario prendas vendedor
   */
  CargarTSEPrendasVendedor() {
    if(this.PrendasVendedorForm.controls["bac.tipo_identificacion_vendedor"].value !== this.TiposIdentificacion[0]){
      return;
    }
    if(!this.PrendasVendedorForm.controls["bac.cedula_vendedor"].value){
      return;
    }
    if(!this.PrendasVendedorForm.controls["bac.Genero_vendedor"].value){
      this.alertsService.ShowBigCenteredAlert("Debe seleccionar el género antes de realizar la búsqueda", ALERTS.warning)
      return;
    }
    this.blockUiHanddler.Start(1, "Buscando cédula...")
    this.templatesService.GetDataTSE(this.PrendasVendedorForm.controls["bac.cedula_vendedor"].value).subscribe(req => {
      if (req.Result) {
        this.blockUiHanddler.Stop()
        this.PrendasVendedorForm.controls["tse.nombre_vendedor"].setValue(req.Data.Name);
        this.PrendasVendedorForm.controls["tse.nacionalidad_vendedor"].setValue(req.Data.Nationality.toLowerCase());
        this.PrendasVendedorForm.controls["tse.estadocivil_vendedor"].setValue(this.GenerateGenderWord(req.Data.CivilStatus.toLowerCase(), this.PrendasVendedorForm.controls["bac.Genero_vendedor"].value));
      } else {
        this.ResetPrendasVendedorForm(true, true);
        this.alertsService.ShowBigCenteredAlert(req.ErrorInfo.Message, ALERTS.error);
        this.blockUiHanddler.Stop();
      }
    }, err => {
      this.ResetPrendasVendedorForm(true, true);
      this.alertsService.ShowSmallCornerAlert(err, ALERTS.error);
      this.blockUiHanddler.Stop();
    });
  }
  CargarRNPrendasSociedadVendedor() {
    if (this.PrendasSociedadVendedorForm.controls["bac.cedula_Sociedad_Vendedor_Tipo"].value &&
      this.PrendasSociedadVendedorForm.controls["bac.cedula_Sociedad_Vendedor_Clase"].value &&
      this.PrendasSociedadVendedorForm.controls["bac.cedula_Sociedad_Vendedor_Consecutivo"].value) {
      this.blockUiHanddler.Start(1, "Buscando cédula jurídica...")
      
      this.templatesService.GetDataRNPersonaJuridica(
        this.ActiveUser.Id,
        this.PrendasSociedadVendedorForm.controls["bac.cedula_Sociedad_Vendedor_Tipo"].value,
        this.PrendasSociedadVendedorForm.controls["bac.cedula_Sociedad_Vendedor_Clase"].value,
        this.PrendasSociedadVendedorForm.controls["bac.cedula_Sociedad_Vendedor_Consecutivo"].value).subscribe(req => {
          this.blockUiHanddler.Stop()
          if (req.Result) {
            if(req.Data.BussinessName){
              this.PrendasSociedadVendedorForm.controls["bac.cedula_Sociedad_Vendedor"].setValue(req.Data.BussinessCard);
              this.PrendasSociedadVendedorForm.controls["rnp.razon_Social_Sociedad_Vendedor"].setValue(req.Data.BussinessName);
            } else {
              this.ResetPrendasSociedadVendedorForm(true);
              this.alertsService.ShowBigCenteredAlert(req.ErrorInfo.Message, ALERTS.error)
            }
          } else {
            this.ResetPrendasSociedadVendedorForm(true);
            this.alertsService.ShowBigCenteredAlert(req.ErrorInfo.Message, ALERTS.error)
          }
        }, err => {
          this.ResetPrendasSociedadVendedorForm(true);
          this.alertsService.ShowBigCenteredAlert(err, ALERTS.error)
          this.blockUiHanddler.Stop()
        });
    }
  }
  /**
   * Carga desde el sitio del TSE los datos de una persona para el formulario apoderado vendedor
   */
  CargarTSEPrendasApoderadoVendedor() {
    if(this.PrendasSociedadVendedorForm.controls["bac.Tipo_identificacion_apoderado_Vendedor"].value !== this.TiposIdentificacion[0]){
      return;
    }
    if(!this.PrendasSociedadVendedorForm.controls["bac.cedula_apoderado_Vendedor"].value){
      return;
    }
    if(!this.PrendasSociedadVendedorForm.controls["bac.Genero_apoderado_vendedor"].value){
      this.alertsService.ShowBigCenteredAlert("Debe seleccionar el género antes de realizar la búsqueda", ALERTS.warning)
      return;
    }
    this.blockUiHanddler.Start(1, "Buscando cédula...")
    this.templatesService.GetDataTSE(this.PrendasSociedadVendedorForm.controls["bac.cedula_apoderado_Vendedor"].value).subscribe(req => {
      if (req.Result) {
        this.blockUiHanddler.Stop()
        this.PrendasSociedadVendedorForm.controls["tse.nombre_apoderado_Vendedor"].setValue(req.Data.Name);
        this.PrendasSociedadVendedorForm.controls["tse.nacionalidad_apoderado_Vendedor"].setValue(req.Data.Nationality.toLowerCase());
        this.PrendasSociedadVendedorForm.controls["tse.estadocivil_apoderado_Vendedor"].setValue(this.GenerateGenderWord(req.Data.CivilStatus.toLowerCase(), this.PrendasSociedadVendedorForm.controls["bac.Genero_apoderado_vendedor"].value));
      } else {
        this.ResetPrendasSociedadVendedorForm(true);
        this.alertsService.ShowBigCenteredAlert(req.ErrorInfo.Message, ALERTS.error);
        this.blockUiHanddler.Stop();
      }
    }, err => {
      this.ResetPrendasSociedadVendedorForm(true);
      this.alertsService.ShowSmallCornerAlert(err, ALERTS.error);
      this.blockUiHanddler.Stop();
    });
  }
  /**
   * Carga desde el sitio del TSE los datos de una persona para el formulario prendas comprador
   */
  CargarTSEPrendasComprador() {
    if(this.PrendasCompradorForm.controls["bac.tipo_identificacion_Comprador"].value !== this.TiposIdentificacion[0]){
      return;
    }
    if(!this.PrendasCompradorForm.controls["bac.cedula_Comprador"].value){
      return;
    }
    if(!this.PrendasCompradorForm.controls["bac.Genero_Comprador"].value){
      this.alertsService.ShowBigCenteredAlert("Debe seleccionar el género antes de realizar la búsqueda", ALERTS.warning)
      return;
    } 
    this.blockUiHanddler.Start(1, "Buscando cédula...")
    this.templatesService.GetDataTSE(this.PrendasCompradorForm.controls["bac.cedula_Comprador"].value).subscribe(req => {
      if (req.Result) {
        this.blockUiHanddler.Stop()
        this.PrendasCompradorForm.controls["tse.nombre_Comprador"].setValue(req.Data.Name);
        this.PrendasCompradorForm.controls["tse.nacionalidad_Comprador"].setValue(req.Data.Nationality.toLowerCase());
        this.PrendasCompradorForm.controls["tse.estadocivil_Comprador"].setValue(this.GenerateGenderWord(req.Data.CivilStatus.toLowerCase(), this.PrendasCompradorForm.controls["bac.Genero_Comprador"].value));
      } else {
        this.ResetPrendasCompradorForm(true, true);
        this.alertsService.ShowBigCenteredAlert(req.ErrorInfo.Message, ALERTS.error);
        this.blockUiHanddler.Stop();
      }
    }, err => {
      this.ResetPrendasCompradorForm(true, true);
      this.alertsService.ShowSmallCornerAlert(err, ALERTS.error);
      this.blockUiHanddler.Stop();
    });
  }
  CargarRNPrendasSociedadComprador() {
    if (this.PrendasSociedadCompradorForm.controls["bac.cedula_Sociedad_Comprador_Tipo"].value &&
      this.PrendasSociedadCompradorForm.controls["bac.cedula_Sociedad_Comprador_Clase"].value &&
      this.PrendasSociedadCompradorForm.controls["bac.cedula_Sociedad_Comprador_Consecutivo"].value) {
      this.blockUiHanddler.Start(1, "Buscando cédula jurídica...")
      
      this.templatesService.GetDataRNPersonaJuridica(
        this.ActiveUser.Id,
        this.PrendasSociedadCompradorForm.controls["bac.cedula_Sociedad_Comprador_Tipo"].value,
        this.PrendasSociedadCompradorForm.controls["bac.cedula_Sociedad_Comprador_Clase"].value,
        this.PrendasSociedadCompradorForm.controls["bac.cedula_Sociedad_Comprador_Consecutivo"].value).subscribe(req => {
          this.blockUiHanddler.Stop()
          if (req.Result) {
            if(req.Data.BussinessName){
              this.PrendasSociedadCompradorForm.controls["bac.cedula_Sociedad_Comprador"].setValue(req.Data.BussinessCard);
              this.PrendasSociedadCompradorForm.controls["rnp.razon_Social_Sociedad_Comprador"].setValue(req.Data.BussinessName);
            } else {
              this.ResetPrendasSociedadCompradorForm(true);
              this.alertsService.ShowBigCenteredAlert(req.ErrorInfo.Message, ALERTS.error)
            }
          } else {
            this.ResetPrendasSociedadCompradorForm(true);
            this.alertsService.ShowBigCenteredAlert(req.ErrorInfo.Message, ALERTS.error)
          }
        }, err => {
          this.ResetPrendasSociedadCompradorForm(true);
          this.alertsService.ShowBigCenteredAlert(err, ALERTS.error)
          this.blockUiHanddler.Stop()
        });
    }
  }
  /**
   * Carga desde el sitio del TSE los datos de una persona para el formulario apoderado comprador
   */
  CargarTSEPrendasApoderadoComprador() {
    if(this.PrendasSociedadCompradorForm.controls["bac.Tipo_identificacion_apoderado_Comprador"].value !== this.TiposIdentificacion[0]){
      return;
    }
    if(!this.PrendasSociedadCompradorForm.controls["bac.cedula_apoderado_Comprador"].value){
      return;
    }
    if(!this.PrendasSociedadCompradorForm.controls["bac.Genero_apoderado_comprador"].value){
      this.alertsService.ShowBigCenteredAlert("Debe seleccionar el género antes de realizar la búsqueda", ALERTS.warning)
      return;
    }
    this.blockUiHanddler.Start(1, "Buscando cédula...")
    this.templatesService.GetDataTSE(this.PrendasSociedadCompradorForm.controls["bac.cedula_apoderado_Comprador"].value).subscribe(req => {
      if (req.Result) {
        this.blockUiHanddler.Stop()
        this.PrendasSociedadCompradorForm.controls["tse.nombre_apoderado_Comprador"].setValue(req.Data.Name);
        this.PrendasSociedadCompradorForm.controls["tse.nacionalidad_apoderado_Comprador"].setValue(req.Data.Nationality.toLowerCase());
        this.PrendasSociedadCompradorForm.controls["tse.estadocivil_apoderado_Comprador"].setValue(this.GenerateGenderWord(req.Data.CivilStatus.toLowerCase(), this.PrendasSociedadCompradorForm.controls["bac.Genero_apoderado_comprador"].value));
      } else {
        this.ResetPrendasSociedadCompradorForm(true);
        this.alertsService.ShowBigCenteredAlert(req.ErrorInfo.Message, ALERTS.error);
        this.blockUiHanddler.Stop();
      }
    }, err => {
      this.ResetPrendasSociedadCompradorForm(true);
      this.alertsService.ShowSmallCornerAlert(err, ALERTS.error);
      this.blockUiHanddler.Stop();
    });
  }
  /**
   * Carga desde el sitio del TSE los datos de una persona para el formulario prendas fiador
   */
  CargarTSEPrendasFiador() {
    if(this.PrendasFiadorForm.controls["bac.tipo_identificacion_Fiador"].value !== this.TiposIdentificacion[0]){
      return;
    }
    if(!this.PrendasFiadorForm.controls["bac.cedula_Fiador"].value){
      return;
    }
    if(!this.PrendasFiadorForm.controls["bac.Genero_Fiador"].value){
      this.alertsService.ShowBigCenteredAlert("Debe seleccionar el género antes de realizar la búsqueda", ALERTS.warning)
      return;
    }  
    this.blockUiHanddler.Start(1, "Buscando cédula...")
    this.templatesService.GetDataTSE(this.PrendasFiadorForm.controls["bac.cedula_Fiador"].value).subscribe(req => {
      if (req.Result) {
        this.blockUiHanddler.Stop()
        this.PrendasFiadorForm.controls["tse.nombre_Fiador"].setValue(req.Data.Name);
        this.PrendasFiadorForm.controls["tse.nacionalidad_Fiador"].setValue(req.Data.Nationality.toLowerCase());
        this.PrendasFiadorForm.controls["tse.estadocivil_Fiador"].setValue(this.GenerateGenderWord(req.Data.CivilStatus.toLowerCase(), this.PrendasFiadorForm.controls["bac.Genero_Fiador"].value));
      } else {
        this.ResetPrendasFiadorForm(true, true);
        this.alertsService.ShowBigCenteredAlert(req.ErrorInfo.Message, ALERTS.error);
        this.blockUiHanddler.Stop();
      }
    }, err => {
      this.ResetPrendasFiadorForm(true, true);
      this.alertsService.ShowSmallCornerAlert(err, ALERTS.error);
      this.blockUiHanddler.Stop();
    });
  }
  /**
   * Carga los datos de un vehículo basado en la placa, la clase y el código de la clase
   */
  CargarRNPrendasVehiculo(): void {
    if (this.PrendasVehiculoForm.controls["bac.numero_placa"].value) {
      this.blockUiHanddler.Start(1, "Buscando vehículo por placa...")

      this.templatesService.GetDataRNVehiculo(
        this.ActiveUser.Id,
        this.PrendasVehiculoForm.controls["bac.numero_placa"].value,
        this.PrendasVehiculoForm.controls["bac.clase_vehiculo"].value?.value,
        this.PrendasVehiculoForm.controls["bac.codigo_vehiculo"].value).subscribe(req => {
          this.blockUiHanddler.Stop()
          if (req.Result) {
            this.PrendasVehiculoForm.controls["rnp.numero_placa"].setValue(req.Data.CardPlate);
            this.PrendasVehiculoForm.controls["rnp.identificacion_propietario"].setValue(req.Data.OwnerCard);
            this.PrendasVehiculoForm.controls["rnp.nombre_propietario"].setValue(req.Data.OwnerName);
            this.PrendasVehiculoForm.controls["rnp.marca_vehiculo"].setValue(req.Data.Brand);
            this.PrendasVehiculoForm.controls["rnp.estilo"].setValue(req.Data.Style);
            this.PrendasVehiculoForm.controls["rnp.categoria"].setValue(req.Data.Category);
            this.PrendasVehiculoForm.controls["rnp.capacidad"].setValue(req.Data.Capacity);
            this.PrendasVehiculoForm.controls["rnp.serie"].setValue(req.Data.Serial);
            this.PrendasVehiculoForm.controls["rnp.chasis"].setValue(req.Data.Chassis);
            this.PrendasVehiculoForm.controls["rnp.vin"].setValue(req.Data.VIN);
            this.PrendasVehiculoForm.controls["rnp.carroceria"].setValue(req.Data.Bodywork);
            this.PrendasVehiculoForm.controls["rnp.traccion"].setValue(req.Data.Traction);
            this.PrendasVehiculoForm.controls["rnp.peso_bruto"].setValue(req.Data.GrossWeight);
            this.PrendasVehiculoForm.controls["rnp.anio_fabricacion"].setValue(req.Data.ProductionYear);
            this.PrendasVehiculoForm.controls["rnp.uso"].setValue(req.Data.Use);
            this.PrendasVehiculoForm.controls["rnp.color"].setValue(req.Data.Color);
            this.PrendasVehiculoForm.controls["rnp.numero_motor"].setValue(req.Data.EngineNumber);
            this.PrendasVehiculoForm.controls["rnp.marca_motor"].setValue(req.Data.EngineBrand);
            this.PrendasVehiculoForm.controls["rnp.combustible"].setValue(req.Data.Fuel);
            this.PrendasVehiculoForm.controls["rnp.cilindrada"].setValue(req.Data.Cylinder);
            this.PrendasVehiculoForm.controls["rnp.potencia"].setValue(req.Data.Power);
            this.PrendasVehiculoForm.controls["rnp.cilindros"].setValue(req.Data.Cylinders);
          } else {
            this.ResetPrendasVehiculoForm(true);
            this.alertsService.ShowBigCenteredAlert(req.ErrorInfo.Message, ALERTS.error)
          }
        }, err => {
          this.ResetPrendasVehiculoForm(true);
          this.alertsService.ShowBigCenteredAlert(err, ALERTS.error)
          this.blockUiHanddler.Stop()
        });
    }
  }

  /**
   * Permite generar y guardar un formato especificado
   * @param key llave o nombre del formato a generar y guardar
   */
  GenerateAndSaveTemplate(key: string){
    
    if(this.ActiveTemplate){
      this.GenerateAndSaveTemplateDocument(key);
    } else {
      this.ActiveTemplate = {
        Id: 0,
        TemplateTypeId: this.ActiveTemplateTypeId,
        Active: true
      };
      
      this.blockUiHanddler.Start(1, "Creando Formato base...");
      this.templatesService.StoreTemplate(this.ActiveTemplate).subscribe(req => {
        this.blockUiHanddler.Stop();
        if(req.Result){ 
          //Obtenermos el template (Cabecera de datos)
          this.ActiveTemplate.Id = req.Data
          for(let tempkey in this.ActiveTemplateDocuments){
            this.ActiveTemplateDocuments[tempkey].TemplateId = this.ActiveTemplate.Id;
            this.ActiveTemplateDocuments[tempkey].Template = this.ActiveTemplate;
          }
          this.GenerateAndSaveTemplateDocument(key);
        }
      }, err => {
        this.blockUiHanddler.Stop();
        this.alertsService.ShowSmallCornerAlert(err, ALERTS.error);
      })
    }
  }

  /**
   * Al utilizarlo de forma recursiva se debe tener mucho cuidado de no crear un ciclo 
   * al reemplazar variables dentro de bloque por otros bloques con reemplazo de variables.
   * @param Text Texto con la variable a reemplazar
   * @param Variable Nombre de la variable
   * @param Variables Conjunto de datos de variables
   * @returns Texto con la variable reemplazada
   */
  ReplaceVariables(Text: string, Variable: string, Variables: { [name: string]: string }): string{

    let Card = '';
    let CivilStatusQuantity = '';
    let ClausuleText = '';
    let CivilStatus = '';
    let aux = '';

    switch(Variable) {
      case 'bac.Genero_fideicomitente_cesionario':
      case 'bac.Genero_apoderado_fideicomitente_original':
      case 'bac.Genero_sociedad_deudor':
      case 'bac.Genero_apoderado_deudor':
      case 'bac.Genero_apoderado_fiduciaria':
      case 'bac.Genero_apoderado_Propietario':
      case 'bac.Genero_sociedad_vendedor':
      case 'bac.Genero_apoderado_vendedor':
      case 'bac.Genero_sociedad_comprador':
      case 'bac.Genero_apoderado_comprador':
      case 'bac.Genero_Fiador':
        return this.ReplaceGenderWords(Text, Variable, Variables);
      case 'bac.Genero_fideicomitente_original':
        if(Variables['bac.Genero_apoderado_fideicomitente_original']){
          aux = Variables['bac.Genero_fideicomitente_original'];
          Variables['bac.Genero_fideicomitente_original'] = Variables['bac.Genero_apoderado_fideicomitente_original'];
          Text = this.ReplaceGenderWords(Text, Variable, Variables);
          Variables['bac.Genero_fideicomitente_original'] = aux;
          return Text;
        } else {
          return this.ReplaceGenderWords(Text, Variable, Variables);
        }
      case 'bac.Genero_propietario_registral':
        if(Variables['bac.Genero_apoderado_Propietario']){
          aux = Variables['bac.Genero_propietario_registral'];
          Variables['bac.Genero_propietario_registral'] = Variables['bac.Genero_apoderado_Propietario'];
          Text = this.ReplaceGenderWords(Text, Variable, Variables);
          Variables['bac.Genero_propietario_registral'] = aux;
          return Text;
        } else {
          return this.ReplaceGenderWords(Text, Variable, Variables);
        }
      case 'bac.Genero_deudor':
        if(Variables['bac.Genero_sociedad_deudor']){
          aux = Variables['bac.Genero_deudor'];
          Variables['bac.Genero_deudor'] = Variables['bac.Genero_sociedad_deudor'];
          Text = this.ReplaceGenderWords(Text, Variable, Variables);
          Variables['bac.Genero_deudor'] = aux;
          return Text;
        } else {
          return this.ReplaceGenderWords(Text, Variable, Variables);
        }
      case 'bac.Genero_vendedor':
        if(Variables['bac.Genero_sociedad_vendedor']){
          aux = Variables['bac.Genero_vendedor'];
          Variables['bac.Genero_vendedor'] = Variables['bac.Genero_sociedad_vendedor'];
          Text = this.ReplaceGenderWords(Text, Variable, Variables);
          Variables['bac.Genero_vendedor'] = aux;
          return Text;
        } else {
          return this.ReplaceGenderWords(Text, Variable, Variables);
        }
      case 'bac.Genero_Comprador':
        if(Variables['bac.Genero_sociedad_comprador']){
          aux = Variables['bac.Genero_Comprador'];
          Variables['bac.Genero_Comprador'] = Variables['bac.Genero_sociedad_comprador'];
          Text = this.ReplaceGenderWords(Text, Variable, Variables);
          Variables['bac.Genero_Comprador'] = aux;
          return Text;
        } else {
          return this.ReplaceGenderWords(Text, Variable, Variables);
        }
      case 'bac.cedula_Fideicomitente_Original':
      case 'bac.cedula_apoderado_fideicomitente_original':
      case 'bac.cedula_Firmante_Fideicomitente_Cesionario':
      case 'bac.cedula_apoderado_fiduciaria':
      case 'bac.cedula_deudor':
      case 'bac.cedula_apoderado_Deudor':
      case 'bac.cedula_propietario_registral':
      case 'bac.cedula_apoderado_Propietario':
      case 'rnp.identificacion_propietario':
      case 'bac.cedula_vendedor':
      case 'bac.cedula_apoderado_Vendedor':
      case 'bac.cedula_Comprador':
      case 'bac.cedula_apoderado_Comprador':
      case 'bac.cedula_Fiador':
        Card = "";
        if(isNaN(parseInt(Variables[Variable]))){
          Card = Variables[Variable] ?? "";
          let numberMatchs = Card.toString().trim().match(/\d+/g);
          if(numberMatchs){
            numberMatchs.forEach(num => {
              Card = Card.toString().trim().replace(new RegExp(num, 'g'), this.numberToWordsPipe.transform(num).trim());
            });
          }
        } 
        else {
          Utils.DivideCard(Variables[Variable].toString().trim()).forEach(x => Card += ` ${this.numberToWordsPipe.transform(x, {type: 'single'})}`);
        }

        return Text.replace(new RegExp(Variable, 'g'), Card.toLowerCase().trim());
      case 'bac.cedula_Sociedad_Fideicomitente_Original':
      case 'bac.cedulajuridica_fiduciaria':
      case 'bac.cedula_Sociedad_Propietario':
      case 'bac.cedula_Sociedad_Deudor':
      case 'bac.cedula_Sociedad_Vendedor':
      case 'bac.cedula_Sociedad_Comprador':
        Card = "";
        if(Variables[Variable] && Variables[`${Variable}_Tipo`] && Variables[`${Variable}_Clase`] && Variables[`${Variable}_Consecutivo`]){
          Card += this.numberToWordsPipe.transform(Variables[`${Variable}_Tipo`], {type: 'single'});
          Card += ` ${this.numberToWordsPipe.transform(Variables[`${Variable}_Clase`], {type: 'single'})}`;
          Card += ` ${this.numberToWordsPipe.transform(Variables[`${Variable}_Consecutivo`], {type: 'single'})}`;
          Card = Card.toLowerCase();
        }

        return Text.replace(new RegExp(Variable, 'g'), Card.trim());
      case 'bac.folio_Real_Finca':
        Card = this.numberToWordsPipe.transform(Variables['bac.folio_Real_Finca']);
        let Horizontal = (Variables['bac.horizontal_Finca'])?` - ${Variables['bac.horizontal_Finca']}`:'';
        let Derecho = (Variables['bac.derecho_Finca'])?` - ${this.numberToWordsPipe.transform(Variables['bac.derecho_Finca']).toString().trim()}`:'';
        return Text.replace(new RegExp(Variable, 'g'), `${Card.trim()}${Horizontal}${Derecho}`);
      case 'bac.suma_Prestamo':
      case 'bac.cuota_Inicial_Prestamo':
      case 'bac.tarifa_Mensual_Fiduciario':
        return Text.replace(
          new RegExp(Variable, 'g'), 
          this.numberToWordsPipe.transform(Variables[Variable].toString().trim().replace(/\,/g, ""), {currency: Variables['bac.moneda']})
        );
      case 'bac.monto_credito':
      case 'bac.cuotas':
        // Se esta pasando dolar quemado, si se define dicha variable se debe cambiar o incluos sumar al flujo de arriba
        return Text.replace(
          new RegExp(Variable, 'g'), 
          this.numberToWordsPipe.transform(Variables[Variable].toString().trim().replace(/\,/g, ""), {currency: Constants.DOLARS})
        );
      case 'bac.plazo_Meses_Prestamo':
      case 'bac.tasa_Fija_Prestamo':
      case 'bac.tasa_Variable_Prestamo':
      case 'bac.tasa_Piso_Prestamo':
      case 'bac.tasa_comision_bancaria':
      case 'bac.meses':
      case 'bac.tasafija':
      case 'bac.comision':
        return Text.replace(
          new RegExp(Variable, 'g'), 
          this.numberToWordsPipe.transform(Variables[Variable].toString().trim().replace(/\,/g, ""))
        );
      case 'bac.valor_Estimado_Finca':
        let monedaFinca = '';
        if(Variables['bac.valor_Moneda_Finca']) monedaFinca = Variables['bac.valor_Moneda_Finca'].toString().trim();
        return Text.replace(
          new RegExp(Variable, 'g'), 
          `${this.numberToWordsPipe.transform(Variables[Variable].toString().trim().replace(/\,/g, ""), {currency: monedaFinca})}`
        );
      case 'tse.estadocivil_Firmante_Fideicomitente_Cesionario':
        if(Variables['bac.cantidad_estadosciviles_Fideicomitente_Cesionario']) CivilStatusQuantity = ` ${Variables['bac.cantidad_estadosciviles_Fideicomitente_Cesionario'].toString().trim()}`;
        return Text.replace(
          new RegExp(Variable, 'g'), 
          `${Variables[Variable].toString().trim()}${CivilStatusQuantity}`
        );
      case 'tse.estadocivil_apoderado_fideicomitente_original':
        if(Variables['bac.cantidad_estadocivil_apoderado_fideicomitente_original']) CivilStatusQuantity = ` ${Variables['bac.cantidad_estadocivil_apoderado_fideicomitente_original'].toString().trim()}`;
        return Text.replace(
          new RegExp(Variable, 'g'), 
          `${Variables[Variable].toString().trim()}${CivilStatusQuantity}`
        );
      case 'tse.estadocivil_Firmante_Fideicomitente_Original':
        if(Variables['bac.cantidad_estadosciviles_Fideicomitente_Original']) CivilStatusQuantity = ` ${Variables['bac.cantidad_estadosciviles_Fideicomitente_Original'].toString().trim()}`;
        return Text.replace(
          new RegExp(Variable, 'g'), 
          `${Variables[Variable].toString().trim()}${CivilStatusQuantity}`
        );
      case 'tse.estadocivil_apoderado_fiduciaria':
        if(Variables['bac.cantidad_estadosciviles_apoderado_fiduciaria']) CivilStatusQuantity = ` ${Variables['bac.cantidad_estadosciviles_apoderado_fiduciaria'].toString().trim()}`;
        return Text.replace(
          new RegExp(Variable, 'g'), 
          `${Variables[Variable].toString().trim()}${CivilStatusQuantity}`
        );
      case 'tse.estadocivil_deudor':
        if(Variables['bac.cantidad_estadosciviles_deudor']) CivilStatusQuantity = ` ${Variables['bac.cantidad_estadosciviles_deudor'].toString().trim()}`;
        return Text.replace(
          new RegExp(Variable, 'g'), 
          `${Variables[Variable].toString().trim()}${CivilStatusQuantity}`
        );
      case 'tse.estadocivil_propietario_registral':
        if(Variables['bac.cantidad_estadosciviles_propietario_registral']) CivilStatusQuantity = ` ${Variables['bac.cantidad_estadosciviles_propietario_registral'].toString().trim()}`;
        return Text.replace(
          new RegExp(Variable, 'g'), 
          `${Variables[Variable].toString().trim()}${CivilStatusQuantity}`
        );
      case 'tse.estadocivil_apoderado_Propietario':
        if(Variables['bac.cantidad_estadosciviles_apoderado_Propietario']) CivilStatusQuantity = ` ${Variables['bac.cantidad_estadosciviles_apoderado_Propietario'].toString().trim()}`;
        return Text.replace(
          new RegExp(Variable, 'g'), 
          `${Variables[Variable].toString().trim()}${CivilStatusQuantity}`
        );
      case 'tse.estadocivil_vendedor':
        if(Variables['bac.cantidad_estadosciviles_vendedor']) CivilStatusQuantity = ` ${Variables['bac.cantidad_estadosciviles_vendedor'].toString().trim()}`;
        return Text.replace(
          new RegExp(Variable, 'g'), 
          `${Variables[Variable].toString().trim()}${CivilStatusQuantity}`
        );
      case 'tse.estadocivil_Comprador':
        if(Variables['bac.cantidad_estadosciviles_Comprador']) CivilStatusQuantity = ` ${Variables['bac.cantidad_estadosciviles_Comprador'].toString().trim()}`;
        return Text.replace(
          new RegExp(Variable, 'g'), 
          `${Variables[Variable].toString().trim()}${CivilStatusQuantity}`
        );
      case 'tse.estadocivil_Fiador':
        if(Variables['bac.cantidad_estadosciviles_Fiador']) CivilStatusQuantity = ` ${Variables['bac.cantidad_estadosciviles_Fiador'].toString().trim()}`;
        return Text.replace(
          new RegExp(Variable, 'g'), 
          `${Variables[Variable].toString().trim()}${CivilStatusQuantity}`
        );
      case 'tse.estadocivil_apoderado_Deudor':
        if(Variables['bac.cantidad_estadosciviles_apoderado_Deudor']) CivilStatusQuantity = ` ${Variables['bac.cantidad_estadosciviles_apoderado_Deudor'].toString().trim()}`;
        return Text.replace(
          new RegExp(Variable, 'g'), 
          `${Variables[Variable].toString().trim()}${CivilStatusQuantity}`
        );
      // Este cambio de la forma de utilizar el estado civil deberia aplicarse a todos los casos anteriores
      case 'tse.estadocivil_apoderado_Vendedor':
        CivilStatus = '';
        if(Variables[Variable]) {
          if(Variables['bac.cantidad_estadosciviles_apoderado_Vendedor']) {
            CivilStatusQuantity = ` ${Variables['bac.cantidad_estadosciviles_apoderado_Vendedor'].toString().trim()}`;
          }
          CivilStatus =`${Variables[Variable].toString().trim()}${CivilStatusQuantity}`
        }
        return Text.replace(new RegExp(Variable, 'g'), CivilStatus);
      case 'tse.estadocivil_apoderado_Comprador':
        CivilStatus = '';
        if(Variables[Variable]) {
          if(Variables['bac.cantidad_estadosciviles_apoderado_Comprador']) {
            CivilStatusQuantity = ` ${Variables['bac.cantidad_estadosciviles_apoderado_Comprador'].toString().trim()}`;
          }
          CivilStatus =`${Variables[Variable].toString().trim()}${CivilStatusQuantity}`
        }
        return Text.replace(new RegExp(Variable, 'g'), CivilStatus);
      case 'bac.fecha_Inicio_Prestamo':
      case 'bac.fecha_Pago_Primer_Cuota_Prestamo':
      case 'bac.fecha_Vencimiento_Prestamo':
      case 'bac.fecha_Inicio_Prenda':
      case 'bac.fecha_Pago_Primer_Cuota_Prenda':
      case 'bac.fecha_Vencimiento_Prenda':
      case 'bac.fecha_firma':
        let dateInWords = '';
        if(Variables[Variable]){
          dateInWords = this.dateToWordsPipe.transform(this.datePipe.transform(Variables[Variable].toString().trim()));
        }   
        return Text.replace(new RegExp(Variable, 'g'), dateInWords.trim());
      case 'bac.clausula_Construccion':
        if(Variables[Variable]){
          if(this.ActiveTemplateKey === TEMPLATES.FIDEICOMISO)
            ClausuleText = this.Blocks['FIDEICOMISO']['CONSTRUCTION_CLAUSULE'];
          if(this.ActiveTemplateKey === TEMPLATES.HIPOTECA)
            ClausuleText = this.Blocks['HIPOTECA']['CONSTRUCTION_CLAUSULE'];
        } else {
          ClausuleText = '';
        }

        // Variables de genero en clausula septima (Se deben agregar otras si se requieren)
        ClausuleText = this.ReplaceGenderWords(ClausuleText, "bac.Genero_deudor", Variables);

        return Text.replace(new RegExp(Variable, 'g'), ClausuleText);
      case 'bac.clausula_Septima':
        if(this.ActiveTemplateKey === TEMPLATES.FIDEICOMISO){
          if(Variables[Variable] === 'primera'){
            ClausuleText = this.Blocks['FIDEICOMISO']['SEVENTH_CLAUSULE']['FIRST_FORTHNIGHT'];
          } else if(Variables[Variable] === 'segunda'){
            ClausuleText = this.Blocks['FIDEICOMISO']['SEVENTH_CLAUSULE']['SECOND_FORTHNIGHT'];
          } else {
            ClausuleText = '';
          }
          if(ClausuleText){
            ClausuleText = this.ReplaceVariables(ClausuleText, 'bac.cuota_Inicial_Prestamo', Variables);
            ClausuleText = this.ReplaceVariables(ClausuleText, 'bac.moneda', Variables);
            ClausuleText = this.ReplaceVariables(ClausuleText, 'bac.fecha_Inicio_Prestamo', Variables);
            ClausuleText = this.ReplaceVariables(ClausuleText, 'bac.fecha_Pago_Primer_Cuota_Prestamo', Variables);
          }
        } else if(this.ActiveTemplateKey === TEMPLATES.HIPOTECA){
          if(Variables[Variable] === 'primera'){
            ClausuleText = this.Blocks['HIPOTECA']['SEVENTH_CLAUSULE']['FIRST_FORTHNIGHT'];
          } else if(Variables[Variable] === 'segunda'){
            ClausuleText = this.Blocks['HIPOTECA']['SEVENTH_CLAUSULE']['SECOND_FORTHNIGHT'];
          } else {
            ClausuleText = '';
          }
          if(ClausuleText){
            ClausuleText = this.ReplaceVariables(ClausuleText, 'bac.cuotas', Variables);
            ClausuleText = this.ReplaceVariables(ClausuleText, 'bac.fecha_Inicio_Prestamo', Variables);
            ClausuleText = this.ReplaceVariables(ClausuleText, 'bac.fecha_Pago_Primer_Cuota_Prestamo', Variables);
          }
        }

        // Variables de genero en clausula septima (Se deben agregar otras si se requieren)
        ClausuleText = this.ReplaceGenderWords(ClausuleText, "bac.Genero_deudor", Variables);
        ClausuleText = this.ReplaceGenderWords(ClausuleText, "bac.Genero_fideicomitente_cesionario", Variables);

        return Text.replace(new RegExp(Variable, 'g'), ClausuleText);
      case 'bac.clausula_comision_prepago':
        ClausuleText = '';

        if(this.ActiveTemplateKey === TEMPLATES.FIDEICOMISO){
          if(Variables[Variable]){
            ClausuleText = this.Blocks['FIDEICOMISO']['PREPAYMENT_CLAUSULE'];
          }

          if(ClausuleText){
            // reemplazo de variables
          }
        } else if(this.ActiveTemplateKey === TEMPLATES.HIPOTECA){
          if(Variables[Variable] === 'corriente'){
            ClausuleText = this.Blocks['HIPOTECA']['PREPAYMENT_CLAUSULE']['CURRENT'];
          } else if(Variables[Variable] === 'switching'){
            ClausuleText = this.Blocks['HIPOTECA']['PREPAYMENT_CLAUSULE']['SWITCHING'];
          }

          if(ClausuleText){
            ClausuleText = this.ReplaceVariables(ClausuleText, 'bac.comision', Variables);
          }
        }

        // Variables de genero en clausula septima (Se deben agregar otras si se requieren)
        ClausuleText = this.ReplaceGenderWords(ClausuleText, "bac.Genero_deudor", Variables);

        return Text.replace(new RegExp(Variable, 'g'), ClausuleText);
      case 'bac.clausula_aseguradora':
        if(Variables[Variable]){
          if(this.ActiveTemplateKey === TEMPLATES.FIDEICOMISO)
            return Text.replace(new RegExp(Variable, 'g'), this.Blocks['FIDEICOMISO']['INSURANCE_CARRIER_CLAUSULE']);
          if(this.ActiveTemplateKey === TEMPLATES.HIPOTECA)
            return Text.replace(new RegExp(Variable, 'g'), this.Blocks['HIPOTECA']['INSURANCE_CARRIER_CLAUSULE']);
          else
            return Text.replace(new RegExp(Variable, 'g'), "");
        } else {
          return Text.replace(new RegExp(Variable, 'g'), "");
        }
      case 'bac.incluir_plano':
        if(this.ActiveTemplateKey === TEMPLATES.FIDEICOMISO){
          return Text.replace(new RegExp(Variable, 'g'), this.Blocks['FIDEICOMISO']['INCLUDE_PLANE']);
        }
        else {
          return Text;
        }
      case 'bac.cuotas_F':
        if(this.ActiveTemplateKey === TEMPLATES.FIDEICOMISO){
          return Text.replace(new RegExp(Variable, 'g'), this.Blocks['FIDEICOMISO']['CUOTAS_F']);
        }
        else {
          return Text;
        }
      case 'bac.traspaso_indirecta':
        if(this.ActiveTemplateKey === TEMPLATES.HIPOTECA && Variables[Variable]){
          return Text.replace(new RegExp(Variable, 'g'), this.Blocks['HIPOTECA']['INDIRECT_TRANSFER']);
        }
        else {
          return Text.replace(new RegExp(Variable, 'g'), '');
        }
      case 'bac.consentimiento':
        ClausuleText = '';

        if(this.ActiveTemplateKey === TEMPLATES.HIPOTECA){
          if(Variables['bac.cedula_deudor'] !== Variables['bac.cedula_propietario_registral']){
            ClausuleText = this.Blocks['HIPOTECA']['CONSENT'];
          }

          if(ClausuleText){
            if(Variables['bac.Genero_apoderado_Propietario']){
              aux = Variables['bac.Genero_propietario_registral'];
              Variables['bac.Genero_propietario_registral'] = Variables['bac.Genero_apoderado_Propietario'];
              ClausuleText = this.ReplaceGenderWords(ClausuleText, "bac.Genero_propietario_registral", Variables);
              Variables['bac.Genero_propietario_registral'] = aux;
            } else {
              ClausuleText = this.ReplaceGenderWords(ClausuleText, "bac.Genero_propietario_registral", Variables);
            }
          }
        }
        else if(this.ActiveTemplateKey === TEMPLATES.PRENDAS){
          if(Variables[Variable]){
            ClausuleText = this.Blocks['PRENDAS']['CONSET'];
          }

          if(ClausuleText){
            // Variables a reemplazar en el bloque de texto
            ClausuleText = this.ReplaceVariables(ClausuleText, 'tse.nombre_apoderado_Deudor', Variables);
            ClausuleText = this.ReplaceVariables(ClausuleText, 'rnp.razon_Social_Sociedad_Deudor', Variables);
          }
        }

        // Variables de genero a reemplazar en el bloque de texto
        ClausuleText = this.ReplaceGenderWords(ClausuleText, "bac.Genero_apoderado_deudor", Variables);
        
        return Text.replace(new RegExp(Variable, 'g'), ClausuleText);
      case 'bac.incisoB':
        // Este inciso parece no estar siendo llamado dentro del texto de hipotecas
        if(Variables['bac.cedula_deudor'] !== Variables['bac.cedula_propietario_registral']){
          return Text.replace(new RegExp(Variable, 'g'), this.Blocks['HIPOTECA']['SUBSECTION_B']);
        } else{
          return Text.replace(new RegExp(Variable, 'g'), '');
        }
      case 'bac.compra_venta':
        ClausuleText = '';

        if(this.ActiveTemplateKey === TEMPLATES.PRENDAS){
          if(Variables[Variable]){
            ClausuleText = this.Blocks['PRENDAS']['COMPRA_VENTA'];
          }

          if(ClausuleText){
            ClausuleText = this.ReplaceVariables(ClausuleText, 'rnp.razon_Social_Sociedad_Vendedor', Variables);
            ClausuleText = this.ReplaceVariables(ClausuleText, 'rnp.razon_Social_Sociedad_Deudor', Variables);
            
            ClausuleText = this.ReplaceVariables(ClausuleText, 'bac.monto_credito', Variables);
            ClausuleText = this.ReplaceVariables(ClausuleText, 'tse.nombre_vendedor', Variables);
            ClausuleText = this.ReplaceVariables(ClausuleText, 'tse.nombre_deudor', Variables);
            ClausuleText = this.ReplaceVariables(ClausuleText, 'tse.nombre_Comprador', Variables);

            ClausuleText = this.ReplaceVariables(ClausuleText, 'tse.nombre_apoderado_Vendedor', Variables);

            ClausuleText = this.ReplaceVariables(ClausuleText, 'bac.numero_placa', Variables);
            ClausuleText = this.ReplaceVariables(ClausuleText, 'rnp.marca_vehiculo', Variables);
            ClausuleText = this.ReplaceVariables(ClausuleText, 'rnp.estilo', Variables);
            ClausuleText = this.ReplaceVariables(ClausuleText, 'rnp.categoria', Variables);
            ClausuleText = this.ReplaceVariables(ClausuleText, 'rnp.capacidad', Variables);
            ClausuleText = this.ReplaceVariables(ClausuleText, 'rnp.serie', Variables);
            ClausuleText = this.ReplaceVariables(ClausuleText, 'rnp.chasis', Variables);
            ClausuleText = this.ReplaceVariables(ClausuleText, 'rnp.vin', Variables);
            ClausuleText = this.ReplaceVariables(ClausuleText, 'rnp.traccion', Variables);
            ClausuleText = this.ReplaceVariables(ClausuleText, 'rnp.peso_bruto', Variables);
            ClausuleText = this.ReplaceVariables(ClausuleText, 'rnp.anio_fabricacion', Variables);
            ClausuleText = this.ReplaceVariables(ClausuleText, 'rnp.uso', Variables);
            ClausuleText = this.ReplaceVariables(ClausuleText, 'rnp.color', Variables);
            ClausuleText = this.ReplaceVariables(ClausuleText, 'rnp.numero_motor', Variables);
            ClausuleText = this.ReplaceVariables(ClausuleText, 'rnp.marca_motor', Variables);
            ClausuleText = this.ReplaceVariables(ClausuleText, 'rnp.combustible', Variables);
            ClausuleText = this.ReplaceVariables(ClausuleText, 'rnp.cilindrada', Variables);
            ClausuleText = this.ReplaceVariables(ClausuleText, 'rnp.potencia', Variables);
            ClausuleText = this.ReplaceVariables(ClausuleText, 'rnp.cilindros', Variables);

            ClausuleText = this.ReplaceVariables(ClausuleText, 'bac.monto_prima', Variables);
            ClausuleText = this.ReplaceVariables(ClausuleText, 'bac.banco_vendedor', Variables);
            ClausuleText = this.ReplaceVariables(ClausuleText, 'bac.cuenta_vendedor', Variables);
            ClausuleText = this.ReplaceVariables(ClausuleText, 'bac.origen_fondos', Variables);
            ClausuleText = this.ReplaceVariables(ClausuleText, 'bac.banco_comprador', Variables);
            ClausuleText = this.ReplaceVariables(ClausuleText, 'bac.cuenta_comprador', Variables);
          }
        }

        ClausuleText = this.ReplaceGenderWords(ClausuleText, "bac.Genero_deudor", Variables);
        ClausuleText = this.ReplaceGenderWords(ClausuleText, "bac.Genero_vendedor", Variables);
        ClausuleText = this.ReplaceGenderWords(ClausuleText, "bac.Genero_Comprador", Variables);
        
        return Text.replace(new RegExp(Variable, 'g'), ClausuleText);
      case 'bac.Comision_Bancaria':
        ClausuleText = '';

        if(this.ActiveTemplateKey === TEMPLATES.PRENDAS){
          if(Variables[Variable]){
            ClausuleText = this.Blocks['PRENDAS']['BANK_COMISION_YES'];
          } else {
            ClausuleText = this.Blocks['PRENDAS']['BANK_COMISION_NO'];
          }

          if(ClausuleText){
            // Variables a reemplazar en el bloque de texto
            // ClausuleText = this.ReplaceVariables(ClausuleText, 'bac.numero_placa', Variables);
          }
        }

        // Variables de genero a reemplazar en el bloque de texto
        ClausuleText = this.ReplaceGenderWords(ClausuleText, "bac.Genero_deudor", Variables);
        
        return Text.replace(new RegExp(Variable, 'g'), ClausuleText);
      case 'bac.Pasivos':
        ClausuleText = '';

        if(this.ActiveTemplateKey === TEMPLATES.PRENDAS){
          if(Variables[Variable]){
            ClausuleText = this.Blocks['PRENDAS']['PASIVES_YES'];
          } else {
            ClausuleText = this.Blocks['PRENDAS']['PASIVES_NO'];
          }

          if(ClausuleText){
            // Variables a reemplazar en el bloque de texto
            // ClausuleText = this.ReplaceVariables(ClausuleText, 'bac.numero_placa', Variables);
          }
        }

        // ClausuleText = this.ReplaceGenderWords(ClausuleText, "bac.Genero_deudor", Variables);
        
        return Text.replace(new RegExp(Variable, 'g'), ClausuleText);
      case 'bac.check_Tasa_Variable':
        ClausuleText = '';

        if(this.ActiveTemplateKey === TEMPLATES.PRENDAS){
          if(Variables[Variable]){
            ClausuleText = this.Blocks['PRENDAS']['VARIABLE_RATE_YES'];
            Text = Text.replace(new RegExp('bac.clausula_Sexta', 'g'), this.Blocks['PRENDAS']['SIXTH_CLAUSULE']);
          } else {
            ClausuleText = this.Blocks['PRENDAS']['VARIABLE_RATE_NO'];
            Text = Text.replace(new RegExp('bac.clausula_Sexta', 'g'), '');
          }

          if(ClausuleText){
            // Variables a reemplazar en el bloque de texto
            ClausuleText = this.ReplaceVariables(ClausuleText, 'bac.tasa_Variable_Prestamo', Variables);
            ClausuleText = this.ReplaceVariables(ClausuleText, 'bac.tasafija', Variables);
            ClausuleText = this.ReplaceVariables(ClausuleText, 'bac.tasa_Piso_Prestamo', Variables);
          }
        }

        // ClausuleText = this.ReplaceGenderWords(ClausuleText, "bac.Genero_deudor", Variables);
        
        return Text.replace(new RegExp(Variable, 'g'), ClausuleText);
      case 'bac.check_fiador':
        ClausuleText = '';

        if(this.ActiveTemplateKey === TEMPLATES.PRENDAS){
          if(Variables[Variable]){
            ClausuleText = this.Blocks['PRENDAS']['GUARANTOR_YES'];
          }

          if(ClausuleText){
            // Variables a reemplazar en el bloque de texto
            ClausuleText = this.ReplaceVariables(ClausuleText, 'tse.nombre_Fiador', Variables);
            ClausuleText = this.ReplaceVariables(ClausuleText, 'rnp.razon_Social_Sociedad_Deudor', Variables);
          }
        }

        // Variables de genero a reemplazar en el bloque de texto
        // ClausuleText = this.ReplaceGenderWords(ClausuleText, "bac.Genero_deudor", Variables);
        
        return Text.replace(new RegExp(Variable, 'g'), ClausuleText);
      case 'tse.nombre_propietario_registral':
        // Este caso es cuanto menos curioso, pues el resultado de esta validacion no impica un cambio real
        // del resultado pues si A y B son iguales se usa A, pero A = B por lo que se usa B 
        // y si A y B son diferentes se usa B que de igual modo es el valor por defencto del resultado de la
        // operacion, basicamente este caso no es necesario, si se plantea como esta actualmente 
        if(Variables['bac.cedula_deudor'] === Variables['bac.cedula_propietario_registral']){
          Text = Text.replace(
            new RegExp("tse.nombre_propietario_registral, de calidades antes dichas, bajo la fe del juramento,", 'g'), 
            `I) Manifiesta ${Variables['tse.nombre_deudor']}, de calidades antes dichas, bajo la fe del juramento,`
          );
        }
        return Text.replace(new RegExp(Variable, 'g'), Variables[Variable].toString().trim());
      case 'bac.cedula_Sociedad_Fideicomitente_Original_Tipo':
      case 'bac.cedula_Sociedad_Fideicomitente_Original_Clase':
      case 'bac.cedula_Sociedad_Fideicomitente_Original_Consecutivo':
      case 'bac.cedulajuridica_fiduciaria_Tipo':
      case 'bac.cedulajuridica_fiduciaria_Clase':
      case 'bac.cedulajuridica_fiduciaria_Consecutivo':
      case 'bac.cedula_Sociedad_Propietario_Tipo':
      case 'bac.cedula_Sociedad_Propietario_Clase':
      case 'bac.cedula_Sociedad_Propietario_Consecutivo':
      case 'bac.cedula_Sociedad_Deudor_Tipo':
      case 'bac.cedula_Sociedad_Deudor_Clase':
      case 'bac.cedula_Sociedad_Deudor_Consecutivo':
      case 'bac.cedula_Sociedad_Vendedor_Tipo':
      case 'bac.cedula_Sociedad_Vendedor_Clase':
      case 'bac.cedula_Sociedad_Vendedor_Consecutivo':
      case 'bac.cedula_Sociedad_Comprador_Tipo':
      case 'bac.cedula_Sociedad_Comprador_Clase':
      case 'bac.cedula_Sociedad_Comprador_Consecutivo':
        return Text;
      case 'rnp.razon_Social_Sociedad_Fideicomitente_Original':
      case 'rnp.razon_Social_fiduciaria':
      case 'rnp.razon_Social_Sociedad_Propietario':
      case 'rnp.razon_Social_Sociedad_Deudor':
      case 'rnp.razon_Social_Sociedad_Vendedor':
      case 'rnp.razon_Social_Sociedad_Comprador':
        return Text.replace(new RegExp(Variable, 'g'), (Variables[Variable] ?? "").toString().trim());
      case 'bac.numero_placa':
      case 'rnp.numero_placa':
        let TempPlaca = Variables['rnp.numero_placa'] ?? "";
        return Text.replace(new RegExp(Variable, 'g'), TempPlaca.toString().trim());
      case 'rnp.chasis':
        let TempChasis = Variables[Variable] ?? "";
        let chasisNumberMatchs = TempChasis.toString().trim().match(/\d+/g);
        if(chasisNumberMatchs){
          chasisNumberMatchs.forEach(num => {
            TempChasis = TempChasis.toString().trim().replace(num, ` ${this.numberToWordsPipe.transform(num).trim()} `);
          });
        }
        return Text.replace(new RegExp(Variable, 'g'), TempChasis.toString().trim());
      case 'bac.domicilio_Firmante_Fideicomitente_Cesionario':
      case 'bac.domicilio_Fideicomitente_Original':
      case 'bac.domicilio_Sociedad_Fideicomitente_Original':
      case 'bac.domicilio_apoderado_fideicomitente_original':
      case 'bac.domicilio_fiduciaria':
      case 'bac.domicilio_apoderado_fiduciaria':
      case 'bac.domicilio_deudor':
      case 'bac.domicilio_propietario_registral':
      case 'bac.domicilio_Sociedad_Propietario':
      case 'bac.domicilio_apoderado_Propietario':
      case 'bac.domicilio_Sociedad_Deudor':
      case 'bac.domicilio_apoderado_Deudor':
      case 'bac.domicilio_vendedor':
      case 'bac.domicilio_Sociedad_Vendedor':
      case 'bac.domicilio_apoderado_Vendedor':
      case 'bac.domicilio_Comprador':
      case 'bac.domicilio_Sociedad_Comprador':
      case 'bac.domicilio_apoderado_Comprador':
      case 'bac.domicilio_Fiador':          
        let TempAddress = Variables[Variable] ?? "";
        // En caso de ser necesario mapear números con decimales
        // let numberMatchsAddress = TempAddress.toString().trim().match(/(\d*[.])?\d+/g);

        // Reemplaza cualquier otro numero en los campos por palabras
        let numberMatchsAddress = TempAddress.toString().trim().match(/\d+/g);
        if(numberMatchsAddress){
          numberMatchsAddress.forEach(num => {
            TempAddress = TempAddress.toString().trim().replace(num, this.numberToWordsPipe.transform(num).toLowerCase().trim());
          });
        }
        return Text.replace(new RegExp(Variable, 'g'), TempAddress.toString().trim());
      default:
        let TempVariable = Variables[Variable] ?? "";
        // Reemplaza cualquier otro numero en los campos por palabras
        let numberMatchs = TempVariable.toString().trim().match(/\d+/g);
        if(numberMatchs){
          numberMatchs.forEach(num => {
            TempVariable = TempVariable.toString().trim().replace(num, this.numberToWordsPipe.transform(num).trim());
          });
        }
        return Text.replace(new RegExp(Variable, 'g'), TempVariable.toString().trim());
    }
  }

  /**
   * Permite generar y guardar el documento en word correspondiente al formato
   * @param key llave o nombre del formato a generar y guardar
   */
  GenerateAndSaveTemplateDocument(key: string){
    this.blockUiHanddler.Start(1,"Guardando formato...")

    //Reset text to origin or saved
    this.ActiveTemplateTexts[key] = this.ActiveTemplateDocuments[key].RawText;
 
    //Reemplazamos variables en el contrato
    let Variables: { [name: string]: string } = this.Forms.reduce<{ [name: string]: string }>((vars, form, index, arr) => Object.assign(vars, form.value), {});

    // Fideicomitente original
    if(Variables['bac.cedula_Fideicomitente_Original']){
      this.ActiveTemplateTexts[key] = this.ReplaceTextVaribles(this.ActiveTemplateTexts[key], 'bac.fideicomitente_original', this.Blocks['FIDEICOMISO']['FIDEICOMITENTE_ORIGINAL']);
      this.ActiveTemplateTexts[key] = this.ReplaceTextVaribles(this.ActiveTemplateTexts[key], 'bac.sociedad_fideicomitente_original', '');
    }
    if(Variables['bac.cedula_Sociedad_Fideicomitente_Original']){
      this.ActiveTemplateTexts[key] = this.ReplaceTextVaribles(this.ActiveTemplateTexts[key], 'bac.fideicomitente_original', ''); 
      this.ActiveTemplateTexts[key] = this.ReplaceTextVaribles(this.ActiveTemplateTexts[key], 'bac.sociedad_fideicomitente_original', this.Blocks['FIDEICOMISO']['SOCIEDAD_FIDEICOMITENTE_ORIGINAL']);
    }

    // Propietario registral
    if(Variables['bac.cedula_propietario_registral']){
      this.ActiveTemplateTexts[key] = this.ReplaceTextVaribles(this.ActiveTemplateTexts[key], 'bac.Propietario', this.Blocks['HIPOTECA']['PROPIETARIO_REGISTRAL']);
      this.ActiveTemplateTexts[key] = this.ReplaceTextVaribles(this.ActiveTemplateTexts[key], 'bac.sociedad_Propietario', '');
    }
    if(Variables['bac.cedula_Sociedad_Propietario']){
      this.ActiveTemplateTexts[key] = this.ReplaceTextVaribles(this.ActiveTemplateTexts[key], 'bac.Propietario', ''); 
      this.ActiveTemplateTexts[key] = this.ReplaceTextVaribles(this.ActiveTemplateTexts[key], 'bac.sociedad_Propietario', this.Blocks['HIPOTECA']['SOCIEDAD_PROPIETARIO_REGISTRAL']);
    }

    if(this.ActiveTemplateKey === TEMPLATES.PRENDAS){
      // Incisos
      let incisos = '';
      let debtor = '';
      let buyer = '';
      let seller = '';
      let guarantor = '';

      if (Variables['bac.cedula_deudor'] || Variables['bac.cedula_Comprador']){
        if (Variables['bac.cedula_deudor'] === Variables['bac.cedula_Comprador']){
          debtor = this.Blocks['PRENDAS']['APPEARING']['DEBTOR_1'];
        } else {
          if (Variables['bac.cedula_deudor']){
            debtor = this.Blocks['PRENDAS']['APPEARING']['DEBTOR_2'];
          }
          if (Variables['bac.cedula_Comprador']){
            buyer = this.Blocks['PRENDAS']['APPEARING']['BUYER'];
          }
        }
      }

      if (Variables['bac.cedula_Sociedad_Deudor'] || Variables['bac.cedula_Sociedad_Comprador']){
        if (Variables['bac.cedula_Sociedad_Deudor'] === Variables['bac.cedula_Sociedad_Comprador']){
          debtor = this.Blocks['PRENDAS']['APPEARING']['DEBTOR_SOCIETY_1'];
        } else {
          if (Variables['bac.cedula_Sociedad_Deudor']){
            debtor = this.Blocks['PRENDAS']['APPEARING']['DEBTOR_SOCIETY_2'];
          }
          if (Variables['bac.cedula_Sociedad_Comprador']){
            buyer = this.Blocks['PRENDAS']['APPEARING']['BUYER_SOCIETY'];
          }
        }
      }

      if (Variables['bac.cedula_vendedor']){
        seller = this.Blocks['PRENDAS']['APPEARING']['SELLER'];
      }

      if (Variables['bac.cedula_Sociedad_Vendedor']){
        seller = this.Blocks['PRENDAS']['APPEARING']['SELLER_SOCIETY'];
      }

      if (Variables['bac.check_fiador']){
        if(Variables['bac.cedula_Fiador'] !== Variables['bac.cedula_apoderado_Deudor']){
          guarantor = this.Blocks['PRENDAS']['APPEARING']['GUARANTOR'];
        } else {
          debtor = this.Blocks['PRENDAS']['APPEARING']['DEBTOR_SOCIETY_GUARANTOR'];
        }
      }

      let letters = ['D','C','B','A'];

      if(debtor){
        incisos += `${letters.pop()}) ${debtor}`;
      }
      if(buyer){
        incisos += `${letters.pop()}) ${buyer}`;
      }
      if(seller){
        incisos += `${letters.pop()}) ${seller}`;
      }
      if(guarantor){
        incisos += `${letters.pop()}) ${guarantor}`;
      }

      this.ActiveTemplateTexts[key] = this.ReplaceTextVaribles(this.ActiveTemplateTexts[key], 'bac.incisos', incisos);

      // Fecha inicio despues del dia 7
      if(Variables['bac.fecha_firma']){
        try {
          let fechaPrenda = new Date(this.datePipe.transform(Variables['bac.fecha_firma']));

          if(fechaPrenda.getDate() >= 7){
            this.ActiveTemplateTexts[key] = this.ReplaceTextVaribles(this.ActiveTemplateTexts[key], 'bac.clausula_fechadespues7', this.Blocks['PRENDAS']['DATE_NEXT_SEVEN_CLAUSULE']);
          } else {
            this.ActiveTemplateTexts[key] = this.ReplaceTextVaribles(this.ActiveTemplateTexts[key], 'bac.clausula_fechadespues7', '');
          }
        } catch (ex){
          console.log(ex);
        }
      } else {
        this.ActiveTemplateTexts[key] = this.ReplaceTextVaribles(this.ActiveTemplateTexts[key], 'bac.clausula_fechadespues7', '');
      }

      if(Variables['bac.fecha_Inicio_Prenda']){
        try {
          let fechaPrenda = new Date(this.datePipe.transform(Variables['bac.fecha_Inicio_Prenda']))
          let month = Constants.Months[fechaPrenda.getMonth()];
          let year = this.numberToWordsPipe.transform(fechaPrenda.getFullYear()+2);

          this.ActiveTemplateTexts[key] = this.ReplaceTextVaribles(this.ActiveTemplateTexts[key], 'bac.mes_finicio', month);
          this.ActiveTemplateTexts[key] = this.ReplaceTextVaribles(this.ActiveTemplateTexts[key], 'bac.año_finicio', year);

        } catch (ex){
          console.log(ex);
        }
      } else {
        this.ActiveTemplateTexts[key] = this.ReplaceTextVaribles(this.ActiveTemplateTexts[key], 'bac.mes_finicio', '');
        this.ActiveTemplateTexts[key] = this.ReplaceTextVaribles(this.ActiveTemplateTexts[key], 'bac.año_finicio', '');
      }
    }

    this.Forms.forEach(form => {
      for(let variable in form.controls){
        this.ActiveTemplateTexts[key] = this.ReplaceVariables(this.ActiveTemplateTexts[key], variable, Variables);
      }
    });

    // ** Por ahora definimos el nombre amigable para las descargas asignando la variable bac.nombre_Fideicomiso, 
    // pero lo adecuando seria un campo con este nombre en la parte superior
    // de ahora en adelante este nombre se define para cada formato de forma diferente
    if(this.ActiveTemplateKey === TEMPLATES.FIDEICOMISO){
      this.ActiveTemplateDocuments[key].FriendlyName = `${(Variables['bac.nombre_Fideicomiso'])? Variables['bac.nombre_Fideicomiso']:'Sin nombre'} (${this.ActiveTemplateDocuments[key].DocumentType.Name})`;
    } else if(this.ActiveTemplateKey === TEMPLATES.HIPOTECA){
      this.ActiveTemplateDocuments[key].FriendlyName = `${this.ActiveTemplateDocuments[key].DocumentType.Name} ${(Variables['tse.nombre_deudor'])? Variables['tse.nombre_deudor']:'Sin deudor'}`;
    } else if(this.ActiveTemplateKey === TEMPLATES.PRENDAS){
      this.ActiveTemplateDocuments[key].FriendlyName = `${(Variables['bac.nombre_Prenda'])? Variables['bac.nombre_Prenda']:'Sin nombre'} (${this.ActiveTemplateDocuments[key].DocumentType.Name})`;
    }

    // Cargamos datos en ejecución al modelo
    this.ActiveTemplateDocuments[key].JsonVariables = JSON.stringify(Variables);

    // Actualizamos usuario
    this.ActiveTemplateDocuments[key].UpdateUserId = this.ActiveUser.Id;
    this.ActiveTemplateDocuments[key].UpdateUser = this.ActiveUser;

    // Eviamos a crear y guardar el documento
    this.templatesService.StoreTemplateDocument(this.ActiveTemplateDocuments[key], this.ActiveTemplateTexts[key]).subscribe(req => {
      this.blockUiHanddler.Stop();
      if(req.Result){
        this.templatesService.GetTemplateDocumentById(req.Data).subscribe( doc => {
          if(doc.Result){
            this.ActiveTemplateDocuments[key] =  doc.Data;
          }
        })
        this.alertsService.ShowSmallCornerAlert("Formato generado y guardado exitosamente", 1);
      } else {
        this.alertsService.ShowSmallCornerAlert(req.ErrorInfo.Message, ALERTS.error);
      }
    }, err => {
      this.blockUiHanddler.Stop();
      this.alertsService.ShowSmallCornerAlert(err, ALERTS.error);
    });
  }

  FormatNumber(Form: FormGroup, key: string): void{
    if(Form.controls[key].value === '') Form.controls[key].setValue("0");
    Form.controls[key].setValue(this.decimalPipe.transform(Form.controls[key].value.replace(/\,/g, ""), '1.0-2'));
  }

  CalculateDueDateFideicomiso(): void{
    if(this.FideicomisoGeneralForm.controls['bac.plazo_Meses_Prestamo'].value && this.FideicomisoGeneralForm.controls['bac.fecha_Inicio_Prestamo'].value){
      let Months: number = Number(this.FideicomisoGeneralForm.controls['bac.plazo_Meses_Prestamo'].value.replace(/\,/g, ""));
      let StartData: Date = new Date(this.datePipe.transform(this.FideicomisoGeneralForm.controls['bac.fecha_Inicio_Prestamo'].value.toString().trim()));
      let DueDate: Date = new Date(StartData.setMonth(StartData.getMonth()+Months));
      this.FideicomisoGeneralForm.controls['bac.fecha_Vencimiento_Prestamo'].setValue(this.datePipe.transform(DueDate, 'yyyy-MM-dd'));
    }
  }

  CalculateDueDateHipoteca(): void{
    if(this.HipotecaGeneralForm.controls['bac.meses'].value && this.HipotecaGeneralForm.controls['bac.fecha_Inicio_Prestamo'].value){
      let Months: number = Number(this.HipotecaGeneralForm.controls['bac.meses'].value.replace(/\,/g, ""));
      let StartData: Date = new Date(this.datePipe.transform(this.HipotecaGeneralForm.controls['bac.fecha_Inicio_Prestamo'].value.toString().trim()));
      let DueDate: Date = new Date(StartData.setMonth(StartData.getMonth()+Months));
      this.HipotecaGeneralForm.controls['bac.fecha_Vencimiento_Prestamo'].setValue(this.datePipe.transform(DueDate, 'yyyy-MM-dd'));
    }
  }

  CalculateDueDatePrendas(): void{
    if(this.PrendasGeneralForm.controls['bac.meses'].value && this.PrendasGeneralForm.controls['bac.fecha_Inicio_Prenda'].value){
      let Months: number = Number(this.PrendasGeneralForm.controls['bac.meses'].value.replace(/\,/g, ""));
      let StartData: Date = new Date(this.datePipe.transform(this.PrendasGeneralForm.controls['bac.fecha_Inicio_Prenda'].value.toString().trim()));
      let DueDate: Date = new Date(StartData.setMonth(StartData.getMonth()+Months-1));
      this.PrendasGeneralForm.controls['bac.fecha_Vencimiento_Prenda'].setValue(this.datePipe.transform(DueDate, 'yyyy-MM-dd'));
    }
  }
  
  Download(Document: ITemplateDocument): void {
    this.blockUiHanddler.Start(1, 'Descargando formato...')
    this.filesService.DownloadDocumentFile(Document.Id).subscribe(response => {
      this.blockUiHanddler.Stop();
      if(response.Result){
        this.commonService.DownloadFile(response.Data.Base64, response.Data.Name, response.Data.Type);
      } else {
        this.alertsService.ShowSmallCornerAlert(response.ErrorInfo.Message, ALERTS.error);
      }
      
    }, error => {
      this.blockUiHanddler.Stop();;
      this.alertsService.ShowSmallCornerAlert(error, ALERTS.error);
    })
  }

  ReplaceTextVaribles(Text: string, Variable: string, Constant: string): string{
    return Text.replace(new RegExp(Variable, 'g'), `${Constant}`);
  }

  VerifySupervisorPermission(Form?: FormGroup, Variable?: string): boolean{
    // Valida los permisos de supervisor y tambien el tipo de cedula para habilitar los campos de datos bloqueados
    if(Form && Variable) {
      return !(this.storageService.GetPermissions().find(x => x.Code === "P_Sup_Temp") || Form.controls[Variable].value !== 'cédula de identidad');
    }
    else {
      return !(this.storageService.GetPermissions().find(x => x.Code === "P_Sup_Temp"));
    }
  }

  LoadActiveForms(): void{
    switch(this.ActiveTemplateKey){
      case TEMPLATES.FIDEICOMISO:
        this.ResetFideicomisoCesionarioForm();
        this.ResetFideicomisoOriginalForm();
        this.ResetFideicomisoSociedadForm();
        this.ResetFideicomisoGeneralForm();
        this.ResetFideicomisoFincaForm();
        this.ResetFideicomisoFiduciariaForm();
        this.ResetFideicomisoApoderadoForm();
        this.ResetFideicomisoDeudorForm();

        this.Forms.push(this.FideicomisoCesionarioForm);
        this.Forms.push(this.FideicomisoOriginalForm);
        this.Forms.push(this.FideicomisoSociedadForm);
        this.Forms.push(this.FideicomisoGeneralForm);
        this.Forms.push(this.FideicomisoFincaForm);
        this.Forms.push(this.FideicomisoFiduciariaForm);
        this.Forms.push(this.FideicomisoApoderadoForm);
        this.Forms.push(this.FideicomisoDeudorForm);
        break;
      case TEMPLATES.HIPOTECA:
        this.ResetHipotecaDeudorForm();
        this.ResetHipotecaGeneralForm();
        this.ResetHipotecaPropietarioForm();
        this.ResetHipotecaSociedadForm();
        this.ResetHipotecaFincaForm();

        this.Forms.push(this.HipotecaDeudorForm);
        this.Forms.push(this.HipotecaGeneralForm);
        this.Forms.push(this.HipotecaPropietarioForm);
        this.Forms.push(this.HipotecaSociedadForm);
        this.Forms.push(this.HipotecaFincaForm);
        break;
      case TEMPLATES.PRENDAS:
        this.ResetPrendasDeudorForm();
        this.ResetPrendasSociedadDeudorForm();
        this.ResetPrendasVendedorForm();
        this.ResetPrendasSociedadVendedorForm();
        this.ResetPrendasCompradorForm();
        this.ResetPrendasSociedadCompradorForm();
        this.ResetPrendasFiadorForm();
        this.ResetPrendasGeneralForm();
        this.ResetPrendasVehiculoForm();

        this.Forms.push(this.PrendasDeudorForm);
        this.Forms.push(this.PrendasSociedadDeudorForm);
        this.Forms.push(this.PrendasVendedorForm);
        this.Forms.push(this.PrendasSociedadVendedorForm);
        this.Forms.push(this.PrendasCompradorForm);
        this.Forms.push(this.PrendasSociedadCompradorForm);
        this.Forms.push(this.PrendasFiadorForm);
        this.Forms.push(this.PrendasGeneralForm);
        this.Forms.push(this.PrendasVehiculoForm);
        break;
      default:
        this.alertsService.ShowBigCenteredAlert("El formulario que esta intentando acceder no está configurado", ALERTS.error);
        break;
    }
  }

  ReplaceGenderWords(Text: string, Variable: string, Variables: { [name: string]: string }): string{
    for(let word in this.GenderWords){
      // Sino se define el genero ahora reemplazamos el texto por vacio en lugar de usar el por default
      let lowerCase = '';
      let capitalize = '';
      let upperCase = '';

      if(Variables[Variable]){
        lowerCase = this.GenderWords[word][Variables[Variable]].toString().trim();
        capitalize = this.GenderWords[word][Variables[Variable]].toString().replace(this.GenderWords[word][Variables[Variable]].toString()[0], this.GenderWords[word][Variables[Variable]].toString()[0].toUpperCase()).trim();
        upperCase = this.GenderWords[word][Variables[Variable]].toString().toUpperCase().trim();
      }

      Text = Text.replace(new RegExp(`${Variable}.${word}`, 'g'), lowerCase);
      Text = Text.replace(new RegExp(`${Variable}.${word.replace(word[0], word[0].toUpperCase())}`, 'g'), capitalize);
      Text = Text.replace(new RegExp(`${Variable}.${word.toUpperCase()}`, 'g'), upperCase);
    }
    return Text;
  }

  /**
   * Permite obtener una variable en un género especifico directamente
   * @param _word variables a consultar en formato "xs"
   * @param _gender genero a aplicar SM, SF, PM o PF
   * @returns la variable con el genero aplicado
   */
  GenerateGenderWord(_word: string, _gender: string): string {
    return this.GenderWords[_word][_gender].toString().trim();
  }

  SelectCardType(Variable: string): void {
    switch(Variable){
      case 'bac.tipo_identificacion_Fideicomitente_Cesionario':
        this.ResetFideicomisoCesionarioForm(false, true);
        break;
      case 'bac.tipo_identificacion_Fideicomitente_Original':
        this.ResetFideicomisoOriginalForm(false, true);
        break;
      case 'bac.Tipo_identificacion_apoderado_fideicomitente_original':
        this.ResetFideicomisoSociedadForm(false, true);
        break;
      case 'bac.Tipo_identificacion_apoderado_fiduciario':
        this.ResetFideicomisoApoderadoForm(false, true);
        break;
      case 'bac.tipo_identificacion_deudor':
        if(this.ActiveTemplateKey === TEMPLATES.HIPOTECA) this.ResetHipotecaDeudorForm(false, true);
        if(this.ActiveTemplateKey === TEMPLATES.PRENDAS) this.ResetPrendasDeudorForm(false, true);
        break;
      case 'bac.Tipo_identificacion_apoderado_Deudor':
        this.ResetPrendasSociedadDeudorForm(false, true);
        break;
      case 'bac.tipo_identificacion_propietario':
        this.ResetHipotecaPropietarioForm(false, true);
        break;
      case 'bac.Tipo_identificacion_apoderado_Propietario':
        this.ResetHipotecaSociedadForm(false, true);
        break;
      case 'bac.tipo_identificacion_vendedor':
        this.ResetPrendasVendedorForm(false, true);
        break;
      case 'bac.Tipo_identificacion_apoderado_Vendedor':
        this.ResetPrendasSociedadVendedorForm(false, true);
        break;
      case 'bac.tipo_identificacion_Comprador':
        this.ResetPrendasCompradorForm(false, true);
        break;
      case 'bac.Tipo_identificacion_apoderado_Comprador':
        this.ResetPrendasSociedadCompradorForm(false, true);
        break;
      case 'bac.tipo_identificacion_Fiador':
        this.ResetPrendasFiadorForm(false, true);
        break;
      default:
        this.alertsService.ShowBigCenteredAlert(`La variable ${Variable} no esta definida para su desbloqueo`, ALERTS.error);
        break;
    }
  }

  /**
   * Actualizada la lista de códigos para vehículos basado en la clase
   */
  UpdateCodes(_preserveCode: boolean = false): void {
    if(!_preserveCode){
      this.PrendasVehiculoForm.controls['bac.codigo_vehiculo'].setValue(undefined);
    }
    this.Codes = this.Clases.find(x => x.value === this.PrendasVehiculoForm.controls['bac.clase_vehiculo'].value?.value)?.codes ?? [];
  }

  /**
   * Filtro para typeahead de clases de vehiculos
   * @param text$ texto de entrada para el filtro
   * @returns Observable con la lista filtrada de clases 
   */
  SearchClass = (text$: Observable<string>): Observable<{ value: string; description: string; codes: { value: string; description: string; }[]; }[]> => {
    const debouncedText$ = text$.pipe(debounceTime(200), distinctUntilChanged());
		const inputFocus$ = this.FocusClass$;
    return merge(debouncedText$, inputFocus$).pipe(
      debounceTime(200),
      distinctUntilChanged(),
      map(term => term.length < 0 ? []
        : this.Clases.filter(cl => cl.description.toUpperCase().indexOf(term.toUpperCase()) > -1).slice(0, 10))
    );
  }

  /**
   * Formateador para el input de clases del typeahead
   * @param cl clase para formatear a la salida del input
   * @returns clase formateada a string
   */
  ClassInputFormatter = (cl: { value: string; description: string }): string => cl.description;

  /**
   * Formateador para el resultado de clases del typeahead
   * @param cl clase para formatear a la salida del resultado
   * @returns clase formateada a string
   */
  ClassResultFormatter = (cl: { value: string; description: string }): string => cl.description;
}
    